// // // src/components/globalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     // Initialize localUserType from user context using 'usertype' property.
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // Ref for notification icon position.
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);

//     // Helper to extract the ticket identifier.
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };

//     // Update localUserType if the user context changes.
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // Calculate the icon's bottom offset.
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//         }
//     }, []);

//     // Fetch notifications for the logged-in user.
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                const res = await fetch(`${backendUrl}/notifications`, { credentials: "include" });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // Socket listener for new notifications.
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             // Extract the ticket identifier from the payload.
//             const receivedTicketId = data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId, // store under the consistent "ticketId"
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             // Play notification sound.
//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark popup notifications as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) =>
//                         n._id === newNotif._id ? { ...n, isSeen: true } : n
//                     )
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     // Count of unseen notifications.
//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // Mark an individual notification as seen.
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     // Handle a notification click: mark as seen and navigate.
//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif || getTicketId(notifications.find((n) => n._id === notifId) || {});

//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error("No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId));
//             return;
//         }
//         // Determine routing based on localUserType; fallback to "client" if undefined.
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // Group notifications by ticket identifier.
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     // Mark all notifications as seen.
//     const handleMarkAllSeen = () => {
//         notifications
//             .filter((n) => !n.isSeen)
//             .forEach((n) => handleMarkSeen(n._id));
//         setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     };

//     return (
//         <>
//             {/* Notification Icon */}
//             <div
//                 ref={iconRef}
//                 style={{
//                     position: "fixed",
//                     top: "60px",
//                     right: "20px",
//                     zIndex: 10000,
//                 }}
//             >
//                 <button
//                     onClick={() => setShowDropdown(!showDropdown)}
//                     style={{
//                         fontSize: "20px",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         position: "relative",
//                     }}
//                 >
//                     🔔
//                     {unseenCount > 0 && (
//                         <span
//                             style={{
//                                 position: "absolute",
//                                 top: "-6px",
//                                 right: "-6px",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "11px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             {unseenCount}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             {/* Notifications Dropdown */}
//             {showDropdown && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: `${notificationsTop}px`,
//                         right: "20px",
//                         width: "400px",
//                         background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//                         borderRadius: "12px",
//                         zIndex: 10000,
//                         padding: "15px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                     }}
//                 >
//                     <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
//                         <strong style={{ fontSize: "16px" }}>Notifications</strong>
//                         <button
//                             onClick={handleMarkAllSeen}
//                             style={{
//                                 fontSize: "12px",
//                                 border: "none",
//                                 background: "none",
//                                 color: "#007bff",
//                                 cursor: "pointer",
//                             }}
//                         >
//                             Mark all seen
//                         </button>
//                     </div>
//                     <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//                         {Object.keys(grouped).length === 0 && (
//                             <div style={{ textAlign: "center", color: "#555" }}>No notifications</div>
//                         )}
//                         {Object.keys(grouped).map((groupKey) => (
//                             <div key={groupKey} style={{ marginBottom: "12px" }}>
//                                 <div
//                                     style={{
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                         marginBottom: "6px",
//                                         borderBottom: "1px solid #ddd",
//                                         paddingBottom: "4px",
//                                     }}
//                                 >
//                                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                 </div>
//                                 {grouped[groupKey].map((notif) => {
//                                     const ticketIdentifier = getTicketId(notif);
//                                     return (
//                                         <div
//                                             key={notif._id}
//                                             onClick={() => handleNavigateToTicket(ticketIdentifier, notif._id)}
//                                             style={{
//                                                 padding: "12px",
//                                                 marginBottom: "8px",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                                                 cursor: "pointer",
//                                                 fontSize: "15px",
//                                                 transition: "background 0.3s ease",
//                                             }}
//                                             onMouseEnter={(e) =>
//                                                 (e.currentTarget.style.backgroundColor = notif.isSeen ? "#eaeaea" : "#c7e7ff")
//                                             }
//                                             onMouseLeave={(e) =>
//                                                 (e.currentTarget.style.backgroundColor = notif.isSeen ? "#f2f2f2" : "#dff4ff")
//                                             }
//                                         >
//                                             {notif.message}
//                                             <div
//                                                 style={{
//                                                     color: "#555",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     marginTop: "4px",
//                                                     fontSize: "13px",
//                                                 }}
//                                             >
//                                                 Ticket: {ticketIdentifier || "N/A"}
//                                             </div>
//                                             <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                                                 {new Date(notif.timestamp).toLocaleString()}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Popup Notifications */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: `${notificationsTop}px`,
//                     right: "20px",
//                     zIndex: 9000,
//                     width: "380px",
//                 }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div
//                             key={n._id}
//                             style={{
//                                 background: "#4b9ef1",
//                                 color: "#fff",
//                                 padding: "12px 16px",
//                                 marginBottom: "10px",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                                 fontSize: "15px",
//                                 transition: "opacity 0.3s ease",
//                             }}
//                         >
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;








// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     // Initialize localUserType from user context using 'usertype' property.
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // Ref for notification icon position.
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);

//     // Helper to extract the ticket identifier.
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };

//     // Update localUserType if the user context changes.
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // Calculate the icon's bottom offset.
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//         }
//     }, []);

//     // Fetch notifications for the logged-in user.
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                 const res = await fetch(`${backendUrl}/notifications`, { credentials: "include" });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // Socket listener for new notifications.
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             // Extract the ticket identifier from the payload.
//             const receivedTicketId = data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId, // store under the consistent "ticketId"
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             // Play notification sound.
//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark popup notifications as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) =>
//                         n._id === newNotif._id ? { ...n, isSeen: true } : n
//                     )
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     // Count of unseen notifications.
//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // Mark an individual notification as seen.
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     // Handle "Mark All Seen" functionality by sending PATCH requests concurrently.
//     const handleMarkAllSeen = async () => {
//         const unseenNotifs = notifications.filter((n) => !n.isSeen);
//         try {
//             await Promise.all(
//                 unseenNotifs.map((n) =>
//                     fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//                         method: "PATCH",
//                         credentials: "include",
//                     })
//                 )
//             );
//             setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//         } catch (err) {
//             console.error("Mark all seen failed:", err.message);
//         }
//     };

//     // Handle a notification click: mark as seen and navigate.
//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif || getTicketId(notifications.find((n) => n._id === notifId) || {});

//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error("No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId));
//             return;
//         }
//         // Determine routing based on localUserType; fallback to "client" if undefined.
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // Group notifications by ticket identifier.
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     return (
//         <>
//             {/* Notification Icon */}
//             <div
//                 ref={iconRef}
//                 style={{
//                     position: "fixed",
//                     top: "60px",
//                     right: "20px",
//                     zIndex: 10000,
//                 }}
//             >
//                 <button
//                     onClick={() => setShowDropdown(!showDropdown)}
//                     style={{
//                         fontSize: "20px",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         position: "relative",
//                     }}
//                 >
//                     🔔
//                     {unseenCount > 0 && (
//                         <span
//                             style={{
//                                 position: "absolute",
//                                 top: "-6px",
//                                 right: "-6px",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "11px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             {unseenCount}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             {/* Notifications Dropdown */}
//             {showDropdown && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: `${notificationsTop}px`,
//                         right: "20px",
//                         width: "400px",
//                         background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//                         borderRadius: "12px",
//                         zIndex: 10000,
//                         padding: "15px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                     }}
//                 >
//                     {/* Header Section with Title, Mark All Seen, and Close Icon */}
//                     <div style={{ position: "relative", marginBottom: "10px" }}>
//                         <strong style={{ fontSize: "16px" }}>Notifications</strong>
//                         <button
//                             onClick={handleMarkAllSeen}
//                             style={{
//                                 fontSize: "12px",
//                                 border: "none",
//                                 background: "none",
//                                 color: "#007bff",
//                                 cursor: "pointer",
//                                 marginLeft: "10px",
//                             }}
//                         >
//                             Mark all seen
//                         </button>
//                         <button
//                             onClick={() => setShowDropdown(false)}
//                             style={{
//                                 position: "absolute",
//                                 top: "4px",
//                                 right: "4px",
//                                 background: "transparent",
//                                 border: "none",
//                                 fontSize: "12px",
//                                 color: "#888",
//                                 cursor: "pointer",
//                                 padding: "2px",
//                             }}
//                             aria-label="Close notifications"
//                         >
//                             &#10006;
//                         </button>
//                     </div>
//                     <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//                         {Object.keys(grouped).length === 0 && (
//                             <div style={{ textAlign: "center", color: "#555" }}>No notifications</div>
//                         )}
//                         {Object.keys(grouped).map((groupKey) => (
//                             <div key={groupKey} style={{ marginBottom: "12px" }}>
//                                 <div
//                                     style={{
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                         marginBottom: "6px",
//                                         borderBottom: "1px solid #ddd",
//                                         paddingBottom: "4px",
//                                     }}
//                                 >
//                                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                 </div>
//                                 {grouped[groupKey].map((notif) => {
//                                     const ticketIdentifier = getTicketId(notif);
//                                     return (
//                                         <div
//                                             key={notif._id}
//                                             onClick={() => handleNavigateToTicket(ticketIdentifier, notif._id)}
//                                             style={{
//                                                 padding: "12px",
//                                                 marginBottom: "8px",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                                                 cursor: "pointer",
//                                                 fontSize: "15px",
//                                                 transition: "background 0.3s ease",
//                                             }}
//                                             onMouseEnter={(e) =>
//                                                 (e.currentTarget.style.backgroundColor = notif.isSeen ? "#eaeaea" : "#c7e7ff")
//                                             }
//                                             onMouseLeave={(e) =>
//                                                 (e.currentTarget.style.backgroundColor = notif.isSeen ? "#f2f2f2" : "#dff4ff")
//                                             }
//                                         >
//                                             {notif.message}
//                                             <div
//                                                 style={{
//                                                     color: "#555",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     marginTop: "4px",
//                                                     fontSize: "13px",
//                                                 }}
//                                             >
//                                                 Ticket: {ticketIdentifier || "N/A"}
//                                             </div>
//                                             <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                                                 {new Date(notif.timestamp).toLocaleString()}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Popup Notifications */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: `${notificationsTop}px`,
//                     right: "20px",
//                     zIndex: 9000,
//                     width: "380px",
//                 }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div
//                             key={n._id}
//                             style={{
//                                 background: "#4b9ef1",
//                                 color: "#fff",
//                                 padding: "12px 16px",
//                                 marginBottom: "10px",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                                 fontSize: "15px",
//                                 transition: "opacity 0.3s ease",
//                             }}
//                         >
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;

































// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Ref for notification icon position.
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);

//   // Helper to extract the ticket identifier.
//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   // Update localUserType if the user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Calculate the icon's bottom offset.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//     }
//   }, []);

//   // Fetch notifications for the logged-in user.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, { credentials: "include" });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listener for new notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;

//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;

//       const receivedTicketId = data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }

//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };

//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }

//       setNotifications((prev) => [...prev, newNotif]);

//       // Auto-mark the popup notification as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) => (n._id === newNotif._id ? { ...n, isSeen: true } : n))
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Handle "Mark All Seen".
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   // Handle a notification click: mark as seen and navigate.
//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});

//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   // Group notifications by ticket identifier.
//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   return (
//     <>
//       {/* Notification Icon */}
//       <div ref={iconRef} className="notification-icon">
//         <button
//           onClick={() => setShowDropdown(!showDropdown)}
//           className="notification-button"
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span className="unseen-count">{unseenCount}</span>
//           )}
//         </button>
//       </div>

//       {/* Notifications Dropdown */}
//       {showDropdown && (
//         <div
//           className="notification-dropdown"
//           style={{ top: `${notificationsTop}px` }}
//         >
//           <div className="notification-header">
//             <strong className="notification-title">Notifications</strong>
//             <button onClick={handleMarkAllSeen} className="mark-all-seen">
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               className="close-button"
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div className="notification-list">
//             {Object.keys(grouped).length === 0 && (
//               <div className="empty-notifications">
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} className="notification-group">
//                 <div className="notification-group-header">
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   const itemClass = notif.isSeen
//                     ? "notification-item seen"
//                     : "notification-item unseen";
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       className={itemClass}
//                     >
//                       {notif.message}
//                       <div className="ticket-info">
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div className="timestamp">
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         className="popup-notifications"
//         style={{ top: `${notificationsTop}px` }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div key={n._id} className="popup-notification">
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;






























// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // --- DRAG & DROP STATE ---
//   // This state tracks the draggable container's fixed position.
//   const notifRef = useRef(null);
//   const [position, setPosition] = useState(() => {
//     const saved = localStorage.getItem("notifPosition");
//     return saved ? JSON.parse(saved) : { x: 20, y: 20 };
//   });
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);

//   // --- ICON REFERENCE FOR POSITIONING ---
//   // This ref is for the notification icon so that the dropdown and popups
//   // can be positioned below it.
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);

//   // --- HELPER FUNCTION ---
//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   // --- UPDATE LOCAL USER TYPE ---
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // --- UPDATE DROPDOWN & POPUP POSITIONING WHEN DRAGGING ---
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//     }
//   }, [position]);

//   // --- SAVE POSITION IN LOCALSTORAGE ---
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // --- FETCH NOTIFICATIONS ---
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // --- SOCKET LISTENER ---
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;

//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;

//       const receivedTicketId = data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }

//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };

//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }

//       setNotifications((prev) => [...prev, newNotif]);

//       // Auto-mark the popup notification as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) => (n._id === newNotif._id ? { ...n, isSeen: true } : n))
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // --- HANDLERS TO MARK NOTIFICATIONS AS SEEN ---
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   // --- NAVIGATION HANDLER ---
//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});

//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   // --- GROUP NOTIFICATIONS ---
//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // --- DRAG & DROP EVENT HANDLERS ---
//   const startDrag = (e) => {
//     dragging.current = true;
//     dragOffset.current = {
//       x: e.clientX - notifRef.current.offsetLeft,
//       y: e.clientY - notifRef.current.offsetTop,
//     };
//     document.addEventListener("mousemove", handleDrag);
//     document.addEventListener("mouseup", stopDrag);
//   };

//   const handleDrag = (e) => {
//     if (dragging.current) {
//       setPosition({
//         x: e.clientX - dragOffset.current.x,
//         y: e.clientY - dragOffset.current.y,
//       });
//     }
//   };

//   const stopDrag = () => {
//     dragging.current = false;
//     document.removeEventListener("mousemove", handleDrag);
//     document.removeEventListener("mouseup", stopDrag);
//   };

//   return (
//     <>
//       {/* Draggable Notification Container */}
//       <div
//         ref={notifRef}
//         className="notification-container"
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 9999,
//           cursor: "move",
//         }}
//         onMouseDown={startDrag}
//       >
//         {/* Notification Icon */}
//         <div ref={iconRef} className="notification-icon">
//           <button
//             onClick={() => setShowDropdown(!showDropdown)}
//             className="notification-button"
//           >
//             🔔
//             {unseenCount > 0 && (
//               <span className="unseen-count">{unseenCount}</span>
//             )}
//           </button>
//         </div>

//         {/* Notifications Dropdown */}
//         {showDropdown && (
//           <div
//             className="notification-dropdown"
//             style={{ top: `${notificationsTop}px` }}
//           >
//             <div className="notification-header">
//               <strong className="notification-title">Notifications</strong>
//               <button onClick={handleMarkAllSeen} className="mark-all-seen">
//                 Mark all seen
//               </button>
//               <button
//                 onClick={() => setShowDropdown(false)}
//                 className="close-button"
//                 aria-label="Close notifications"
//               >
//                 &#10006;
//               </button>
//             </div>
//             <div className="notification-list">
//               {Object.keys(grouped).length === 0 && (
//                 <div className="empty-notifications">No notifications</div>
//               )}
//               {Object.keys(grouped).map((groupKey) => (
//                 <div key={groupKey} className="notification-group">
//                   <div className="notification-group-header">
//                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                   </div>
//                   {grouped[groupKey].map((notif) => {
//                     const ticketIdentifier = getTicketId(notif);
//                     const itemClass = notif.isSeen
//                       ? "notification-item seen"
//                       : "notification-item unseen";
//                     return (
//                       <div
//                         key={notif._id}
//                         onClick={() =>
//                           handleNavigateToTicket(ticketIdentifier, notif._id)
//                         }
//                         className={itemClass}
//                       >
//                         {notif.message}
//                         <div className="ticket-info">
//                           Ticket: {ticketIdentifier || "N/A"}
//                         </div>
//                         <div className="timestamp">
//                           {new Date(notif.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Popup Notifications (positioned outside the draggable container) */}
//       <div
//         className="popup-notifications"
//         style={{ top: `${notificationsTop}px` }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div key={n._id} className="popup-notification">
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;
























// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // --- DRAG & DROP STATE ---
//   const notifRef = useRef(null);
//   const [position, setPosition] = useState(() => {
//     const saved = localStorage.getItem("notifPosition");
//     return saved ? JSON.parse(saved) : { x: 20, y: 20 };
//   });
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);

//   // --- ICON REFERENCE FOR POSITIONING ---
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);

//   // --- HELPER FUNCTION ---
//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   // --- UPDATE LOCAL USER TYPE ---
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // --- UPDATE DROPDOWN & POPUP POSITIONING WHEN DRAGGING ---
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//     }
//   }, [position]);

//   // --- SAVE POSITION IN LOCALSTORAGE ---
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // --- FETCH NOTIFICATIONS ---
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // --- SOCKET LISTENER ---
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;

//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;

//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }

//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };

//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }

//       setNotifications((prev) => [...prev, newNotif]);

//       // Auto-mark the popup notification as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) => (n._id === newNotif._id ? { ...n, isSeen: true } : n))
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // --- HANDLERS TO MARK NOTIFICATIONS AS SEEN ---
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   // --- NAVIGATION HANDLER ---
//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});

//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   // --- GROUP NOTIFICATIONS ---
//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // --- DRAG & DROP EVENT HANDLERS (for the drag handle only) ---
//   const startDrag = (e) => {
//     // Prevent default behavior (like text selection)
//     e.preventDefault();
//     dragging.current = true;
//     dragOffset.current = {
//       x: e.clientX - notifRef.current.offsetLeft,
//       y: e.clientY - notifRef.current.offsetTop,
//     };
//     document.addEventListener("mousemove", handleDrag);
//     document.addEventListener("mouseup", stopDrag);
//   };

//   const handleDrag = (e) => {
//     if (dragging.current) {
//       setPosition({
//         x: e.clientX - dragOffset.current.x,
//         y: e.clientY - dragOffset.current.y,
//       });
//     }
//   };

//   const stopDrag = () => {
//     dragging.current = false;
//     document.removeEventListener("mousemove", handleDrag);
//     document.removeEventListener("mouseup", stopDrag);
//   };

//   return (
//     <>
//       {/* Draggable Notification Container */}
//       <div
//         ref={notifRef}
//         className="notification-container"
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 9999,
//         }}
//       >
//         {/* Drag Handle for moving the container */}
//         <div
//           className="notification-drag-handle"
//           onMouseDown={startDrag}
//           style={{ cursor: "move", userSelect: "none" }}
//         >
//           <div ref={iconRef} className="notification-icon">
//             <button
//               onClick={() => setShowDropdown(!showDropdown)}
//               className="notification-button"
//             >
//               🔔
//               {unseenCount > 0 && (
//                 <span className="unseen-count">{unseenCount}</span>
//               )}
//             </button>
//           </div>
//         </div>

//         {/* Notifications Dropdown */}
//         {showDropdown && (
//           <div
//             className="notification-dropdown"
//             style={{ top: `${notificationsTop}px` }}
//           >
//             <div className="notification-header">
//               <strong className="notification-title">Notifications</strong>
//               <button onClick={handleMarkAllSeen} className="mark-all-seen">
//                 Mark all seen
//               </button>
//               <button
//                 onClick={() => setShowDropdown(false)}
//                 className="close-button"
//                 aria-label="Close notifications"
//               >
//                 &#10006;
//               </button>
//             </div>
//             <div className="notification-list">
//               {Object.keys(grouped).length === 0 && (
//                 <div className="empty-notifications">No notifications</div>
//               )}
//               {Object.keys(grouped).map((groupKey) => (
//                 <div key={groupKey} className="notification-group">
//                   <div className="notification-group-header">
//                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                   </div>
//                   {grouped[groupKey].map((notif) => {
//                     const ticketIdentifier = getTicketId(notif);
//                     const itemClass = notif.isSeen
//                       ? "notification-item seen"
//                       : "notification-item unseen";
//                     return (
//                       <div
//                         key={notif._id}
//                         onClick={() =>
//                           handleNavigateToTicket(ticketIdentifier, notif._id)
//                         }
//                         className={itemClass}
//                       >
//                         {notif.message}
//                         <div className="ticket-info">
//                           Ticket: {ticketIdentifier || "N/A"}
//                         </div>
//                         <div className="timestamp">
//                           {new Date(notif.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Popup Notifications (positioned outside the draggable container) */}
//       <div
//         className="popup-notifications"
//         style={{ top: `${notificationsTop}px` }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div key={n._id} className="popup-notification">
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;


















// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // --- DRAG & DROP STATE ---
//     const notifRef = useRef(null);
//     const [position, setPosition] = useState(() => {
//         const saved = localStorage.getItem("notifPosition");
//         return saved ? JSON.parse(saved) : { x: 20, y: 20 };
//     });
//     const dragOffset = useRef({ x: 0, y: 0 });
//     const dragging = useRef(false);

//     // --- ICON REFERENCE FOR POSITIONING ---
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);

//     // --- HELPER FUNCTION ---
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };

//     // --- UPDATE LOCAL USER TYPE ---
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // --- UPDATE DROPDOWN & POPUP POSITIONING WHEN DRAGGING ---
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//         }
//     }, [position]);

//     // --- SAVE POSITION IN LOCALSTORAGE ---
//     useEffect(() => {
//         localStorage.setItem("notifPosition", JSON.stringify(position));
//     }, [position]);

//     // --- FETCH NOTIFICATIONS ---
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                 const res = await fetch(`${backendUrl}/notifications`, {
//                     credentials: "include",
//                 });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // --- SOCKET LISTENER ---
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             const receivedTicketId =
//                 data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId,
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark the popup notification as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) => (n._id === newNotif._id ? { ...n, isSeen: true } : n))
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // --- HANDLERS TO MARK NOTIFICATIONS AS SEEN ---
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     const handleMarkAllSeen = async () => {
//         const unseenNotifs = notifications.filter((n) => !n.isSeen);
//         try {
//             await Promise.all(
//                 unseenNotifs.map((n) =>
//                     fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//                         method: "PATCH",
//                         credentials: "include",
//                     })
//                 )
//             );
//             setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//         } catch (err) {
//             console.error("Mark all seen failed:", err.message);
//         }
//     };

//     // --- NAVIGATION HANDLER ---
//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif ||
//             getTicketId(notifications.find((n) => n._id === notifId) || {});

//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error(
//                 "No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId)
//             );
//             return;
//         }
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // --- GROUP NOTIFICATIONS ---
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     // --- DRAG & DROP EVENT HANDLERS ---
//     const startDrag = (e) => {
//         e.preventDefault();
//         dragging.current = true;
//         dragOffset.current = {
//             x: e.clientX - position.x,
//             y: e.clientY - position.y,
//         };
//         document.addEventListener("mousemove", handleDrag);
//         document.addEventListener("mouseup", stopDrag);
//     };

//     const handleDrag = (e) => {
//         if (!dragging.current) return;
//         setPosition({
//             x: e.clientX - dragOffset.current.x,
//             y: e.clientY - dragOffset.current.y,
//         });
//     };

//     const stopDrag = () => {
//         dragging.current = false;
//         document.removeEventListener("mousemove", handleDrag);
//         document.removeEventListener("mouseup", stopDrag);
//     };

//     return (
//         <>
//             {/* Draggable Notification Container */}
//             <div
//                 ref={notifRef}
//                 className="notification-container"
//                 style={{
//                     position: "fixed",
//                     top: position.y,
//                     left: position.x,
//                     zIndex: 9999,
//                 }}
//             >
//                 {/* Explicit Drag Handle */}
//                 <div
//                     onMouseDown={startDrag}
//                     style={{ cursor: "move", userSelect: "none", padding: "4px", background: "#4b9ef1", borderRadius: "5px" }}
//                 >
//                     🔔 Move
//                 </div>

//                 {/* Notification Icon (clickable, no drag) */}
//                 <div ref={iconRef} className="notification-icon">
//                     <button
//                         onClick={() => setShowDropdown(!showDropdown)}
//                         className="notification-button"
//                     >
//                         🔔
//                         {unseenCount > 0 && (
//                             <span className="unseen-count">{unseenCount}</span>
//                         )}
//                     </button>
//                 </div>

//                 {/* Notifications Dropdown */}
//                 {showDropdown && (
//                     <div className="notification-dropdown" style={{ top: `${notificationsTop}px` }}>
//                         <div className="notification-header">
//                             <strong className="notification-title">Notifications</strong>
//                             <button onClick={handleMarkAllSeen} className="mark-all-seen">
//                                 Mark all seen
//                             </button>
//                             <button
//                                 onClick={() => setShowDropdown(false)}
//                                 className="close-button"
//                                 aria-label="Close notifications"
//                             >
//                                 &#10006;
//                             </button>
//                         </div>
//                         <div className="notification-list">
//                             {Object.keys(grouped).length === 0 && (
//                                 <div className="empty-notifications">No notifications</div>
//                             )}
//                             {Object.keys(grouped).map((groupKey) => (
//                                 <div key={groupKey} className="notification-group">
//                                     <div className="notification-group-header">
//                                         {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                     </div>
//                                     {grouped[groupKey].map((notif) => {
//                                         const ticketIdentifier = getTicketId(notif);
//                                         const itemClass = notif.isSeen
//                                             ? "notification-item seen"
//                                             : "notification-item unseen";
//                                         return (
//                                             <div
//                                                 key={notif._id}
//                                                 onClick={() =>
//                                                     handleNavigateToTicket(ticketIdentifier, notif._id)
//                                                 }
//                                                 className={itemClass}
//                                             >
//                                                 {notif.message}
//                                                 <div className="ticket-info">
//                                                     Ticket: {ticketIdentifier || "N/A"}
//                                                 </div>
//                                                 <div className="timestamp">
//                                                     {new Date(notif.timestamp).toLocaleString()}
//                                                 </div>
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* Popup Notifications (positioned outside the draggable container) */}
//             <div
//                 className="popup-notifications"
//                 style={{ top: `${notificationsTop}px` }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div key={n._id} className="popup-notification">
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;

























// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     // localUserType is used for route navigation.
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // DRAG & DROP STATE
//     // Compute initial position – if no saved position, default so that the icon appears near the top–right.
//     const [position, setPosition] = useState(() => {
//         const saved = localStorage.getItem("notifPosition");
//         if (saved) return JSON.parse(saved);
//         // Default: position the icon approximately at top right.
//         return { x: window.innerWidth - 70, y: 60 };
//     });
//     // Save position changes.
//     useEffect(() => {
//         localStorage.setItem("notifPosition", JSON.stringify(position));
//     }, [position]);

//     // Refs to help track dragging and click vs. drag.
//     const dragging = useRef(false);
//     const dragOffset = useRef({ x: 0, y: 0 });
//     const dragStart = useRef({ x: 0, y: 0 });
//     const isDragging = useRef(false);
//     const dragThreshold = 5; // pixels – if movement is above this, it’s a drag.

//     // ICON REFERENCE and dropdown positioning.
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);
//     const [iconLeft, setIconLeft] = useState(0);

//     // Update icon position offsets when the position changes.
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//             setIconLeft(rect.left);
//         }
//     }, [position]);

//     // Update localUserType if the user context changes.
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // FETCH NOTIFICATIONS
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                 const res = await fetch(`${backendUrl}/notifications`, {
//                     credentials: "include",
//                 });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // SOCKET LISTENER for new notifications.
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             const receivedTicketId =
//                 data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId, // consistently use ticketId
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark popup notifications as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) =>
//                         n._id === newNotif._id ? { ...n, isSeen: true } : n
//                     )
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     // Count of unseen notifications.
//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // Mark an individual notification as seen.
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     // Mark all notifications as seen.
//     const handleMarkAllSeen = async () => {
//         const unseenNotifs = notifications.filter((n) => !n.isSeen);
//         try {
//             await Promise.all(
//                 unseenNotifs.map((n) =>
//                     fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//                         method: "PATCH",
//                         credentials: "include",
//                     })
//                 )
//             );
//             setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//         } catch (err) {
//             console.error("Mark all seen failed:", err.message);
//         }
//     };

//     // Handle navigation when a notification is clicked.
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };

//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif ||
//             getTicketId(notifications.find((n) => n._id === notifId) || {});
//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error(
//                 "No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId)
//             );
//             return;
//         }
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // Group notifications by ticket (or "other").
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     // DRAG & DROP EVENT HANDLERS:
//     const handleMouseDown = (e) => {
//         dragStart.current = { x: e.clientX, y: e.clientY };
//         dragging.current = true;
//         isDragging.current = false;
//         dragOffset.current = {
//             x: e.clientX - position.x,
//             y: e.clientY - position.y,
//         };
//         document.addEventListener("mousemove", handleMouseMove);
//         document.addEventListener("mouseup", handleMouseUp);
//     };

//     const handleMouseMove = (e) => {
//         if (!dragging.current) return;
//         const deltaX = e.clientX - dragStart.current.x;
//         const deltaY = e.clientY - dragStart.current.y;
//         const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//         if (!isDragging.current && distance > dragThreshold) {
//             isDragging.current = true;
//         }
//         if (isDragging.current) {
//             setPosition({
//                 x: e.clientX - dragOffset.current.x,
//                 y: e.clientY - dragOffset.current.y,
//             });
//         }
//     };

//     const handleMouseUp = (e) => {
//         document.removeEventListener("mousemove", handleMouseMove);
//         document.removeEventListener("mouseup", handleMouseUp);
//         if (!isDragging.current) {
//             // If no dragging took place, treat as a click: toggle dropdown.
//             setShowDropdown((prev) => !prev);
//         }
//         dragging.current = false;
//         isDragging.current = false;
//     };

//     return (
//         <>
//             {/* Draggable Notification Icon Container */}
//             <div
//                 onMouseDown={handleMouseDown}
//                 style={{
//                     position: "fixed",
//                     top: position.y,
//                     left: position.x,
//                     zIndex: 10000,
//                     cursor: "move",
//                     userSelect: "none",
//                 }}
//             >
//                 <button
//                     ref={iconRef}
//                     style={{
//                         fontSize: "20px",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         position: "relative",
//                         outline: "none",
//                     }}
//                 >
//                     🔔
//                     {unseenCount > 0 && (
//                         <span
//                             style={{
//                                 position: "absolute",
//                                 top: "-6px",
//                                 right: "-6px",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "11px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             {unseenCount}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             {/* Dropdown Notifications anchored to the icon's position */}
//             {showDropdown && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: `${notificationsTop}px`,
//                         left: `${iconLeft}px`,
//                         width: "400px",
//                         background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//                         borderRadius: "12px",
//                         zIndex: 10000,
//                         padding: "15px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                     }}
//                 >
//                     {/* Header Section */}
//                     <div style={{ position: "relative", marginBottom: "10px" }}>
//                         <strong style={{ fontSize: "16px" }}>Notifications</strong>
//                         <button
//                             onClick={handleMarkAllSeen}
//                             style={{
//                                 fontSize: "12px",
//                                 border: "none",
//                                 background: "none",
//                                 color: "#007bff",
//                                 cursor: "pointer",
//                                 marginLeft: "10px",
//                             }}
//                         >
//                             Mark all seen
//                         </button>
//                         <button
//                             onClick={() => setShowDropdown(false)}
//                             style={{
//                                 position: "absolute",
//                                 top: "4px",
//                                 right: "4px",
//                                 background: "transparent",
//                                 border: "none",
//                                 fontSize: "12px",
//                                 color: "#888",
//                                 cursor: "pointer",
//                                 padding: "2px",
//                             }}
//                             aria-label="Close notifications"
//                         >
//                             &#10006;
//                         </button>
//                     </div>
//                     {/* Notification List */}
//                     <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//                         {Object.keys(grouped).length === 0 && (
//                             <div style={{ textAlign: "center", color: "#555" }}>
//                                 No notifications
//                             </div>
//                         )}
//                         {Object.keys(grouped).map((groupKey) => (
//                             <div key={groupKey} style={{ marginBottom: "12px" }}>
//                                 <div
//                                     style={{
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                         marginBottom: "6px",
//                                         borderBottom: "1px solid #ddd",
//                                         paddingBottom: "4px",
//                                     }}
//                                 >
//                                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                 </div>
//                                 {grouped[groupKey].map((notif) => {
//                                     const ticketIdentifier = getTicketId(notif);
//                                     return (
//                                         <div
//                                             key={notif._id}
//                                             onClick={() =>
//                                                 handleNavigateToTicket(ticketIdentifier, notif._id)
//                                             }
//                                             style={{
//                                                 padding: "12px",
//                                                 marginBottom: "8px",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                                                 cursor: "pointer",
//                                                 fontSize: "15px",
//                                                 transition: "background 0.3s ease",
//                                             }}
//                                             onMouseEnter={(e) =>
//                                             (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                 ? "#eaeaea"
//                                                 : "#c7e7ff")
//                                             }
//                                             onMouseLeave={(e) =>
//                                             (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                 ? "#f2f2f2"
//                                                 : "#dff4ff")
//                                             }
//                                         >
//                                             {notif.message}
//                                             <div
//                                                 style={{
//                                                     color: "#555",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     marginTop: "4px",
//                                                     fontSize: "13px",
//                                                 }}
//                                             >
//                                                 Ticket: {ticketIdentifier || "N/A"}
//                                             </div>
//                                             <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                                                 {new Date(notif.timestamp).toLocaleString()}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Popup Notifications (anchored to the icon) */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: `${notificationsTop}px`,
//                     left: `${iconLeft}px`,
//                     zIndex: 9000,
//                     width: "380px",
//                 }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div
//                             key={n._id}
//                             style={{
//                                 background: "#4b9ef1",
//                                 color: "#fff",
//                                 padding: "12px 16px",
//                                 marginBottom: "10px",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                                 fontSize: "15px",
//                                 transition: "opacity 0.3s ease",
//                             }}
//                         >
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;
















// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // DRAG & DROP STATE
//     const [position, setPosition] = useState(() => {
//         const saved = localStorage.getItem("notifPosition");
//         if (saved) return JSON.parse(saved);
//         // Default position: near the top–right.
//         return { x: window.innerWidth - 70, y: 60 };
//     });
//     useEffect(() => {
//         localStorage.setItem("notifPosition", JSON.stringify(position));
//     }, [position]);

//     // Refs to track drag state.
//     const dragging = useRef(false);
//     const dragOffset = useRef({ x: 0, y: 0 });
//     const dragStart = useRef({ x: 0, y: 0 });
//     const isDragging = useRef(false);
//     const dragThreshold = 5; // pixels threshold for drag vs. click

//     // Reference for the draggable container.
//     const notifRef = useRef(null);

//     // ICON REFERENCE & Dropdown positioning.
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);
//     const [iconLeft, setIconLeft] = useState(0);
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//             setIconLeft(rect.left);
//         }
//     }, [position]);

//     // Update localUserType if user context changes.
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // FETCH NOTIFICATIONS.
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                 const res = await fetch(`${backendUrl}/notifications`, {
//                     credentials: "include",
//                 });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // SOCKET LISTENER for real-time notifications.
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             const receivedTicketId =
//                 data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId,
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark popup notifications as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) =>
//                         n._id === newNotif._id ? { ...n, isSeen: true } : n
//                     )
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     // Count of unseen notifications.
//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // Mark an individual notification as seen.
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     // Mark all notifications as seen.
//     const handleMarkAllSeen = async () => {
//         const unseenNotifs = notifications.filter((n) => !n.isSeen);
//         try {
//             await Promise.all(
//                 unseenNotifs.map((n) =>
//                     fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//                         method: "PATCH",
//                         credentials: "include",
//                     })
//                 )
//             );
//             setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//         } catch (err) {
//             console.error("Mark all seen failed:", err.message);
//         }
//     };

//     // Navigation handler when a notification is clicked.
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };
//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif ||
//             getTicketId(notifications.find((n) => n._id === notifId) || {});
//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error(
//                 "No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId)
//             );
//             return;
//         }
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // Group notifications by ticket identifier.
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     // Helper function to clamp values.
//     const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//     // DRAG & DROP EVENT HANDLERS.
//     const handleMouseDown = (e) => {
//         dragStart.current = { x: e.clientX, y: e.clientY };
//         dragging.current = true;
//         isDragging.current = false;
//         dragOffset.current = {
//             x: e.clientX - position.x,
//             y: e.clientY - position.y,
//         };
//         document.addEventListener("mousemove", handleMouseMove);
//         document.addEventListener("mouseup", handleMouseUp);
//     };

//     const handleMouseMove = (e) => {
//         if (!dragging.current) return;
//         const deltaX = e.clientX - dragStart.current.x;
//         const deltaY = e.clientY - dragStart.current.y;
//         const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//         if (!isDragging.current && distance > dragThreshold) {
//             isDragging.current = true;
//         }
//         if (isDragging.current) {
//             // Constrain movement so the container cannot go closer than 5px from any screen edge.
//             const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//             const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//             const minX = 5;
//             const minY = 5;
//             const maxX = window.innerWidth - containerWidth - 5;
//             const maxY = window.innerHeight - containerHeight - 5;
//             const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//             const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//             setPosition({ x: newX, y: newY });
//         }
//     };

//     const handleMouseUp = (e) => {
//         document.removeEventListener("mousemove", handleMouseMove);
//         document.removeEventListener("mouseup", handleMouseUp);
//         // If dragging didn't occur, treat the action as a click.
//         if (!isDragging.current) {
//             setShowDropdown((prev) => !prev);
//         }
//         dragging.current = false;
//         isDragging.current = false;
//     };

//     return (
//         <>
//             {/* Draggable Notification Icon Container */}
//             <div
//                 ref={notifRef}
//                 onMouseDown={handleMouseDown}
//                 style={{
//                     position: "fixed",
//                     top: position.y,
//                     left: position.x,
//                     zIndex: 10000,
//                     cursor: "move",
//                     userSelect: "none",
//                 }}
//             >
//                 <button
//                     ref={iconRef}
//                     style={{
//                         fontSize: "20px",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         position: "relative",
//                         outline: "none",
//                     }}
//                 >
//                     🔔
//                     {unseenCount > 0 && (
//                         <span
//                             style={{
//                                 position: "absolute",
//                                 top: "-6px",
//                                 right: "-6px",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "11px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             {unseenCount}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             {/* Dropdown Notifications anchored to the icon – positioned to its left */}
//             {showDropdown && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: `${notificationsTop}px`,
//                         left: `${iconLeft}px`,
//                         transform: "translateX(-100%)",
//                         width: "400px",
//                         background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//                         borderRadius: "12px",
//                         zIndex: 10000,
//                         padding: "15px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                     }}
//                 >
//                     {/* Header Section */}
//                     <div style={{ position: "relative", marginBottom: "10px" }}>
//                         <strong style={{ fontSize: "16px" }}>Notifications</strong>
//                         <button
//                             onClick={handleMarkAllSeen}
//                             style={{
//                                 fontSize: "12px",
//                                 border: "none",
//                                 background: "none",
//                                 color: "#007bff",
//                                 cursor: "pointer",
//                                 marginLeft: "10px",
//                             }}
//                         >
//                             Mark all seen
//                         </button>
//                         <button
//                             onClick={() => setShowDropdown(false)}
//                             style={{
//                                 position: "absolute",
//                                 top: "4px",
//                                 right: "4px",
//                                 background: "transparent",
//                                 border: "none",
//                                 fontSize: "12px",
//                                 color: "#888",
//                                 cursor: "pointer",
//                                 padding: "2px",
//                             }}
//                             aria-label="Close notifications"
//                         >
//                             &#10006;
//                         </button>
//                     </div>
//                     {/* Notification List */}
//                     <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//                         {Object.keys(grouped).length === 0 && (
//                             <div style={{ textAlign: "center", color: "#555" }}>
//                                 No notifications
//                             </div>
//                         )}
//                         {Object.keys(grouped).map((groupKey) => (
//                             <div key={groupKey} style={{ marginBottom: "12px" }}>
//                                 <div
//                                     style={{
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                         marginBottom: "6px",
//                                         borderBottom: "1px solid #ddd",
//                                         paddingBottom: "4px",
//                                     }}
//                                 >
//                                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                 </div>
//                                 {grouped[groupKey].map((notif) => {
//                                     const ticketIdentifier = getTicketId(notif);
//                                     return (
//                                         <div
//                                             key={notif._id}
//                                             onClick={() =>
//                                                 handleNavigateToTicket(ticketIdentifier, notif._id)
//                                             }
//                                             style={{
//                                                 padding: "12px",
//                                                 marginBottom: "8px",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                                                 cursor: "pointer",
//                                                 fontSize: "15px",
//                                                 transition: "background 0.3s ease",
//                                             }}
//                                             onMouseEnter={(e) =>
//                                             (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                 ? "#eaeaea"
//                                                 : "#c7e7ff")
//                                             }
//                                             onMouseLeave={(e) =>
//                                             (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                 ? "#f2f2f2"
//                                                 : "#dff4ff")
//                                             }
//                                         >
//                                             {notif.message}
//                                             <div
//                                                 style={{
//                                                     color: "#555",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     marginTop: "4px",
//                                                     fontSize: "13px",
//                                                 }}
//                                             >
//                                                 Ticket: {ticketIdentifier || "N/A"}
//                                             </div>
//                                             <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                                                 {new Date(notif.timestamp).toLocaleString()}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Popup Notifications anchored to the icon – also shifted left */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: `${notificationsTop}px`,
//                     left: `${iconLeft}px`,
//                     transform: "translateX(-100%)",
//                     zIndex: 9000,
//                     width: "380px",
//                 }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div
//                             key={n._id}
//                             style={{
//                                 background: "#4b9ef1",
//                                 color: "#fff",
//                                 padding: "12px 16px",
//                                 marginBottom: "10px",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                                 fontSize: "15px",
//                                 transition: "opacity 0.3s ease",
//                             }}
//                         >
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;























// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // DRAG & DROP STATE with safe check for window/localStorage:
//     const [position, setPosition] = useState(() => {
//         if (typeof window !== "undefined") {
//             const saved = localStorage.getItem("notifPosition");
//             if (saved) return JSON.parse(saved);
//             // Default position: near the top–right.
//             return { x: window.innerWidth - 70, y: 60 };
//         }
//         // Fallback if window is undefined:
//         return { x: 300, y: 60 };
//     });
//     useEffect(() => {
//         if (typeof window !== "undefined") {
//             localStorage.setItem("notifPosition", JSON.stringify(position));
//         }
//     }, [position]);

//     // Refs to track drag state.
//     const dragging = useRef(false);
//     const dragOffset = useRef({ x: 0, y: 0 });
//     const dragStart = useRef({ x: 0, y: 0 });
//     const isDragging = useRef(false);
//     const dragThreshold = 5; // pixels threshold for drag vs. click

//     // Reference for the draggable container.
//     const notifRef = useRef(null);

//     // ICON REFERENCE & Dropdown positioning.
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);
//     const [iconLeft, setIconLeft] = useState(0);
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//             setIconLeft(rect.left);
//         }
//     }, [position]);

//     // Update localUserType if user context changes.
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // FETCH NOTIFICATIONS.
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                 const res = await fetch(`${backendUrl}/notifications`, {
//                     credentials: "include",
//                 });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // SOCKET LISTENER for real-time notifications.
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             const receivedTicketId =
//                 data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId,
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark popup notifications as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) =>
//                         n._id === newNotif._id ? { ...n, isSeen: true } : n
//                     )
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     // Count of unseen notifications.
//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // Mark an individual notification as seen.
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) =>
//                     n._id === notifId ? { ...n, isSeen: true } : n
//                 )
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     // Mark all notifications as seen.
//     const handleMarkAllSeen = async () => {
//         const unseenNotifs = notifications.filter((n) => !n.isSeen);
//         try {
//             await Promise.all(
//                 unseenNotifs.map((n) =>
//                     fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//                         method: "PATCH",
//                         credentials: "include",
//                     })
//                 )
//             );
//             setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//         } catch (err) {
//             console.error("Mark all seen failed:", err.message);
//         }
//     };

//     // Navigation handler when a notification is clicked.
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };
//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif ||
//             getTicketId(notifications.find((n) => n._id === notifId) || {});
//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error(
//                 "No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId)
//             );
//             return;
//         }
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // Group notifications by ticket identifier.
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     // Helper function to clamp values.
//     const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//     // DRAG & DROP EVENT HANDLERS.
//     const handleMouseDown = (e) => {
//         dragStart.current = { x: e.clientX, y: e.clientY };
//         dragging.current = true;
//         isDragging.current = false;
//         dragOffset.current = {
//             x: e.clientX - position.x,
//             y: e.clientY - position.y,
//         };
//         document.addEventListener("mousemove", handleMouseMove);
//         document.addEventListener("mouseup", handleMouseUp);
//     };

//     const handleMouseMove = (e) => {
//         if (!dragging.current) return;
//         const deltaX = e.clientX - dragStart.current.x;
//         const deltaY = e.clientY - dragStart.current.y;
//         const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//         if (!isDragging.current && distance > dragThreshold) {
//             isDragging.current = true;
//         }
//         if (isDragging.current) {
//             // Constrain movement so the container cannot go closer than 5px from any screen edge.
//             const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//             const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//             const minX = 5;
//             const minY = 5;
//             const maxX = window.innerWidth - containerWidth - 5;
//             const maxY = window.innerHeight - containerHeight - 5;
//             const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//             const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//             setPosition({ x: newX, y: newY });
//         }
//     };

//     const handleMouseUp = () => {
//         document.removeEventListener("mousemove", handleMouseMove);
//         document.removeEventListener("mouseup", handleMouseUp);
//         // If dragging didn't occur, treat the action as a click.
//         if (!isDragging.current) {
//             setShowDropdown((prev) => !prev);
//         }
//         dragging.current = false;
//         isDragging.current = false;
//     };

//     return (
//         <>
//             {/* Draggable Notification Icon Container */}
//             <div
//                 ref={notifRef}
//                 onMouseDown={handleMouseDown}
//                 style={{
//                     position: "fixed",
//                     top: position.y,
//                     left: position.x,
//                     zIndex: 10000,
//                     cursor: "move",
//                     userSelect: "none",
//                 }}
//             >
//                 <button
//                     ref={iconRef}
//                     style={{
//                         fontSize: "20px",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         position: "relative",
//                         outline: "none",
//                     }}
//                 >
//                     🔔
//                     {unseenCount > 0 && (
//                         <span
//                             style={{
//                                 position: "absolute",
//                                 top: "-6px",
//                                 right: "-6px",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "11px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             {unseenCount}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             {/* Dropdown Notifications anchored to the icon – positioned to its left */}
//             {showDropdown && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: `${notificationsTop}px`,
//                         left: `${iconLeft}px`,
//                         transform: "translateX(-100%)",
//                         width: "400px",
//                         background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//                         borderRadius: "12px",
//                         zIndex: 10000,
//                         padding: "15px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                     }}
//                 >
//                     {/* Header Section */}
//                     <div style={{ position: "relative", marginBottom: "10px" }}>
//                         <strong style={{ fontSize: "16px" }}>Notifications</strong>
//                         <button
//                             onClick={handleMarkAllSeen}
//                             style={{
//                                 fontSize: "12px",
//                                 border: "none",
//                                 background: "none",
//                                 color: "#007bff",
//                                 cursor: "pointer",
//                                 marginLeft: "10px",
//                             }}
//                         >
//                             Mark all seen
//                         </button>
//                         <button
//                             onClick={() => setShowDropdown(false)}
//                             style={{
//                                 position: "absolute",
//                                 top: "4px",
//                                 right: "4px",
//                                 background: "transparent",
//                                 border: "none",
//                                 fontSize: "12px",
//                                 color: "#888",
//                                 cursor: "pointer",
//                                 padding: "2px",
//                             }}
//                             aria-label="Close notifications"
//                         >
//                             &#10006;
//                         </button>
//                     </div>
//                     {/* Notification List */}
//                     <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//                         {Object.keys(grouped).length === 0 && (
//                             <div style={{ textAlign: "center", color: "#555" }}>
//                                 No notifications
//                             </div>
//                         )}
//                         {Object.keys(grouped).map((groupKey) => (
//                             <div key={groupKey} style={{ marginBottom: "12px" }}>
//                                 <div
//                                     style={{
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                         marginBottom: "6px",
//                                         borderBottom: "1px solid #ddd",
//                                         paddingBottom: "4px",
//                                     }}
//                                 >
//                                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                 </div>
//                                 {grouped[groupKey].map((notif) => {
//                                     const ticketIdentifier = getTicketId(notif);
//                                     return (
//                                         <div
//                                             key={notif._id}
//                                             onClick={() =>
//                                                 handleNavigateToTicket(ticketIdentifier, notif._id)
//                                             }
//                                             style={{
//                                                 padding: "12px",
//                                                 marginBottom: "8px",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                                                 cursor: "pointer",
//                                                 fontSize: "15px",
//                                                 transition: "background 0.3s ease",
//                                             }}
//                                             onMouseEnter={(e) =>
//                                             (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                 ? "#eaeaea"
//                                                 : "#c7e7ff")
//                                             }
//                                             onMouseLeave={(e) =>
//                                             (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                 ? "#f2f2f2"
//                                                 : "#dff4ff")
//                                             }
//                                         >
//                                             {notif.message}
//                                             <div
//                                                 style={{
//                                                     color: "#555",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     marginTop: "4px",
//                                                     fontSize: "13px",
//                                                 }}
//                                             >
//                                                 Ticket: {ticketIdentifier || "N/A"}
//                                             </div>
//                                             <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                                                 {new Date(notif.timestamp).toLocaleString()}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Popup Notifications anchored to the icon – also shifted left */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: `${notificationsTop}px`,
//                     left: `${iconLeft}px`,
//                     transform: "translateX(-100%)",
//                     zIndex: 9000,
//                     width: "380px",
//                 }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div
//                             key={n._id}
//                             style={{
//                                 background: "#4b9ef1",
//                                 color: "#fff",
//                                 padding: "12px 16px",
//                                 marginBottom: "10px",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                                 fontSize: "15px",
//                                 transition: "opacity 0.3s ease",
//                             }}
//                         >
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;





















// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//     const { user, isUserLoaded } = useContext(UserContext);
//     const [localUserType, setLocalUserType] = useState(user?.usertype);
//     const [notifications, setNotifications] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const isSocketSetup = useRef(false);
//     const userId = user?._id || user?.id;
//     const navigate = useNavigate();
//     const audioRef = useRef(new Audio("/notification-sound.mp3"));

//     // DRAG & DROP STATE
//     // Default position: 30px from top and 10px from right.
//     // We assume a default icon width of ~40px so left = window.innerWidth - (40 + 10) = window.innerWidth - 50.
//     const [position, setPosition] = useState(() => {
//         if (typeof window !== "undefined") {
//             const saved = localStorage.getItem("notifPosition");
//             if (saved) return JSON.parse(saved);
//             return { x: window.innerWidth - 50, y: 30 };
//         }
//         return { x: 300, y: 30 };
//     });
//     useEffect(() => {
//         if (typeof window !== "undefined") {
//             localStorage.setItem("notifPosition", JSON.stringify(position));
//         }
//     }, [position]);

//     // Refs to track drag state.
//     const dragging = useRef(false);
//     const dragOffset = useRef({ x: 0, y: 0 });
//     const dragStart = useRef({ x: 0, y: 0 });
//     const isDragging = useRef(false);
//     const dragThreshold = 5; // pixels threshold for drag vs. click

//     // Reference for the draggable container.
//     const notifRef = useRef(null);

//     // ICON REFERENCE & Dropdown positioning.
//     const iconRef = useRef(null);
//     const [notificationsTop, setNotificationsTop] = useState(0);
//     const [iconLeft, setIconLeft] = useState(0);
//     useEffect(() => {
//         if (iconRef.current) {
//             const rect = iconRef.current.getBoundingClientRect();
//             setNotificationsTop(rect.bottom + 8);
//             setIconLeft(rect.left);
//         }
//     }, [position]);

//     // Update localUserType if user context changes.
//     useEffect(() => {
//         if (user && (user.usertype || user.userType)) {
//             setLocalUserType(user.usertype || user.userType);
//         }
//     }, [user]);

//     // FETCH NOTIFICATIONS.
//     useEffect(() => {
//         if (!userId || !isUserLoaded) return;
//         const fetchNotifications = async () => {
//             try {
//                 const res = await fetch(`${backendUrl}/notifications`, {
//                     credentials: "include",
//                 });
//                 const data = await res.json();
//                 if (res.ok && data.notifications) {
//                     setNotifications(data.notifications);
//                 }
//             } catch (err) {
//                 console.error("Error fetching notifications:", err.message);
//             }
//         };
//         fetchNotifications();
//     }, [userId, isUserLoaded]);

//     // SOCKET LISTENER for real-time notifications.
//     useEffect(() => {
//         if (!userId || !isUserLoaded || isSocketSetup.current) return;

//         socket.emit("registerUser", userId);
//         isSocketSetup.current = true;

//         socket.on("chatNotification", (data) => {
//             if (data.targetUserId !== userId) return;

//             const receivedTicketId =
//                 data.ticketId || data.ticketID || data.ticketNumber;
//             if (!receivedTicketId) {
//                 console.warn("No ticket identifier found in notification payload:", data);
//             } else {
//                 console.log("Extracted ticket identifier:", receivedTicketId);
//             }

//             const newNotif = {
//                 _id: Date.now().toString(),
//                 message: data.message,
//                 ticketId: receivedTicketId,
//                 from: data.from,
//                 isSeen: false,
//                 timestamp: new Date(),
//             };

//             try {
//                 audioRef.current?.play();
//             } catch (e) {
//                 console.warn("Unable to play sound:", e.message);
//             }

//             setNotifications((prev) => [...prev, newNotif]);

//             // Auto-mark popup notifications as seen after 6 seconds.
//             setTimeout(() => {
//                 setNotifications((prev) =>
//                     prev.map((n) =>
//                         n._id === newNotif._id ? { ...n, isSeen: true } : n
//                     )
//                 );
//             }, 6000);
//         });

//         return () => {
//             socket.off("chatNotification");
//         };
//     }, [userId, isUserLoaded]);

//     // Count of unseen notifications.
//     const unseenCount = notifications.filter((n) => !n.isSeen).length;

//     // Mark an individual notification as seen.
//     const handleMarkSeen = async (notifId) => {
//         try {
//             await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//                 method: "PATCH",
//                 credentials: "include",
//             });
//             setNotifications((prev) =>
//                 prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//             );
//         } catch (err) {
//             console.error("Mark seen failed:", err.message);
//         }
//     };

//     // Mark all notifications as seen.
//     const handleMarkAllSeen = async () => {
//         const unseenNotifs = notifications.filter((n) => !n.isSeen);
//         try {
//             await Promise.all(
//                 unseenNotifs.map((n) =>
//                     fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//                         method: "PATCH",
//                         credentials: "include",
//                     })
//                 )
//             );
//             setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//         } catch (err) {
//             console.error("Mark all seen failed:", err.message);
//         }
//     };

//     // Navigation handler when a notification is clicked.
//     const getTicketId = (notif) => {
//         return notif.ticketId || notif.ticketID || notif.ticketNumber;
//     };
//     const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//         const finalTicketId =
//             ticketIdFromNotif ||
//             getTicketId(notifications.find((n) => n._id === notifId) || {});
//         if (notifId) {
//             await handleMarkSeen(notifId);
//         }
//         if (!finalTicketId) {
//             console.error(
//                 "No ticket identifier found for navigation. Notification details:",
//                 notifications.find((n) => n._id === notifId)
//             );
//             return;
//         }
//         const userRole = localUserType ? localUserType.toLowerCase() : "client";
//         if (userRole === "manager" || userRole === "general manager") {
//             navigate(`/manager/${finalTicketId}`);
//         } else if (userRole === "client") {
//             navigate(`/client/${finalTicketId}`);
//         } else if (userRole === "tasker") {
//             navigate(`/tasker/${finalTicketId}`);
//         } else if (userRole === "implementer") {
//             navigate(`/implementer/${finalTicketId}`);
//         } else {
//             navigate(`/client/${finalTicketId}`);
//         }
//     };

//     // Group notifications by ticket identifier.
//     const grouped = notifications.reduce((acc, notif) => {
//         const groupKey = getTicketId(notif) || "other";
//         acc[groupKey] = acc[groupKey] || [];
//         acc[groupKey].push(notif);
//         return acc;
//     }, {});

//     // Helper function to clamp values.
//     const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//     // DRAG & DROP EVENT HANDLERS.
//     const handleMouseDown = (e) => {
//         dragStart.current = { x: e.clientX, y: e.clientY };
//         dragging.current = true;
//         isDragging.current = false;
//         dragOffset.current = {
//             x: e.clientX - position.x,
//             y: e.clientY - position.y,
//         };
//         document.addEventListener("mousemove", handleMouseMove);
//         document.addEventListener("mouseup", handleMouseUp);
//     };

//     const handleMouseMove = (e) => {
//         if (!dragging.current) return;
//         const deltaX = e.clientX - dragStart.current.x;
//         const deltaY = e.clientY - dragStart.current.y;
//         const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//         if (!isDragging.current && distance > dragThreshold) {
//             isDragging.current = true;
//         }
//         if (isDragging.current) {
//             // Constrain movement so the container cannot go closer than:
//             // 10px from the left and right and 30px from the top, 10px from the bottom.
//             const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//             const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//             const minX = 10;
//             const minY = 30;
//             const maxX = window.innerWidth - containerWidth - 10;
//             const maxY = window.innerHeight - containerHeight - 10;
//             const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//             const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//             setPosition({ x: newX, y: newY });
//         }
//     };

//     const handleMouseUp = () => {
//         document.removeEventListener("mousemove", handleMouseMove);
//         document.removeEventListener("mouseup", handleMouseUp);
//         // If dragging didn't occur, treat the action as a click.
//         if (!isDragging.current) {
//             setShowDropdown((prev) => !prev);
//         }
//         dragging.current = false;
//         isDragging.current = false;
//     };

//     return (
//         <>
//             {/* Draggable Notification Icon Container */}
//             <div
//                 ref={notifRef}
//                 onMouseDown={handleMouseDown}
//                 style={{
//                     position: "fixed",
//                     top: position.y,
//                     left: position.x,
//                     zIndex: 10000,
//                     cursor: "move",
//                     userSelect: "none",
//                 }}
//             >
//                 <button
//                     ref={iconRef}
//                     style={{
//                         fontSize: "20px",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         position: "relative",
//                         outline: "none",
//                     }}
//                 >
//                     🔔
//                     {unseenCount > 0 && (
//                         <span
//                             style={{
//                                 position: "absolute",
//                                 top: "-6px",
//                                 right: "-6px",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "11px",
//                                 width: "16px",
//                                 height: "16px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                             }}
//                         >
//                             {unseenCount}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             {/* Dropdown Notifications anchored to the icon – positioned to its left */}
//             {showDropdown && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: `${notificationsTop}px`,
//                         left: `${iconLeft}px`,
//                         transform: "translateX(-100%)",
//                         width: "400px",
//                         background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//                         borderRadius: "12px",
//                         zIndex: 10000,
//                         padding: "15px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                     }}
//                 >
//                     {/* Header Section */}
//                     <div style={{ position: "relative", marginBottom: "10px" }}>
//                         <strong style={{ fontSize: "16px" }}>Notifications</strong>
//                         <button
//                             onClick={handleMarkAllSeen}
//                             style={{
//                                 fontSize: "12px",
//                                 border: "none",
//                                 background: "none",
//                                 color: "#007bff",
//                                 cursor: "pointer",
//                                 marginLeft: "10px",
//                             }}
//                         >
//                             Mark all seen
//                         </button>
//                         <button
//                             onClick={() => setShowDropdown(false)}
//                             style={{
//                                 position: "absolute",
//                                 top: "4px",
//                                 right: "4px",
//                                 background: "transparent",
//                                 border: "none",
//                                 fontSize: "12px",
//                                 color: "#888",
//                                 cursor: "pointer",
//                                 padding: "2px",
//                             }}
//                             aria-label="Close notifications"
//                         >
//                             &#10006;
//                         </button>
//                     </div>
//                     {/* Notification List */}
//                     <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//                         {Object.keys(grouped).length === 0 && (
//                             <div style={{ textAlign: "center", color: "#555" }}>
//                                 No notifications
//                             </div>
//                         )}
//                         {Object.keys(grouped).map((groupKey) => (
//                             <div key={groupKey} style={{ marginBottom: "12px" }}>
//                                 <div
//                                     style={{
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                         marginBottom: "6px",
//                                         borderBottom: "1px solid #ddd",
//                                         paddingBottom: "4px",
//                                     }}
//                                 >
//                                     {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                                 </div>
//                                 {grouped[groupKey].map((notif) => {
//                                     const ticketIdentifier = getTicketId(notif);
//                                     return (
//                                         <div
//                                             key={notif._id}
//                                             onClick={() =>
//                                                 handleNavigateToTicket(ticketIdentifier, notif._id)
//                                             }
//                                             style={{
//                                                 padding: "12px",
//                                                 marginBottom: "8px",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                                                 cursor: "pointer",
//                                                 fontSize: "15px",
//                                                 transition: "background 0.3s ease",
//                                             }}
//                                             onMouseEnter={(e) =>
//                                                 (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                     ? "#eaeaea"
//                                                     : "#c7e7ff")
//                                             }
//                                             onMouseLeave={(e) =>
//                                                 (e.currentTarget.style.backgroundColor = notif.isSeen
//                                                     ? "#f2f2f2"
//                                                     : "#dff4ff")
//                                             }
//                                         >
//                                             {notif.message}
//                                             <div
//                                                 style={{
//                                                     color: "#555",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     marginTop: "4px",
//                                                     fontSize: "13px",
//                                                 }}
//                                             >
//                                                 Ticket: {ticketIdentifier || "N/A"}
//                                             </div>
//                                             <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                                                 {new Date(notif.timestamp).toLocaleString()}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Popup Notifications anchored to the icon – also shifted left */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: `${notificationsTop}px`,
//                     left: `${iconLeft}px`,
//                     transform: "translateX(-100%)",
//                     zIndex: 9000,
//                     width: "380px",
//                 }}
//             >
//                 {notifications
//                     .filter((n) => !n.isSeen)
//                     .slice(-3)
//                     .map((n) => (
//                         <div
//                             key={n._id}
//                             style={{
//                                 background: "#4b9ef1",
//                                 color: "#fff",
//                                 padding: "12px 16px",
//                                 marginBottom: "10px",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                                 fontSize: "15px",
//                                 transition: "opacity 0.3s ease",
//                             }}
//                         >
//                             {n.message}
//                         </div>
//                     ))}
//             </div>
//         </>
//     );
// };

// export default GlobalNotification;
























// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Refs to track drag state.
//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragStart = useRef({ x: 0, y: 0 });
//   const isDragging = useRef(false);
//   const dragThreshold = 5; // pixels threshold for drag vs. click

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Update notification dropdown position based on icon position.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Update localUserType if user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // FETCH NOTIFICATIONS.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // SOCKET LISTENER for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;

//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;

//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn(
//           "No ticket identifier found in notification payload:",
//           data
//         );
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }

//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };

//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }

//       setNotifications((prev) => [...prev, newNotif]);

//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   // Count of unseen notifications.
//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Mark all notifications as seen.
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   // Navigation handler when a notification is clicked.
//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };
//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   // Group notifications by ticket identifier.
//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // Helper function to clamp values.
//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // --------------------
//   // DRAG & DROP HANDLERS
//   // --------------------

//   // Mouse Events
//   const handleMouseDown = (e) => {
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > dragThreshold) {
//       isDragging.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!isDragging.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//   };

//   // Touch Events for Mobile Devices
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > dragThreshold) {
//       isDragging.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!isDragging.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//   };

//   // Update positions on window resize to keep component in view.
//   useEffect(() => {
//     const handleResize = () => {
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition((pos) => ({
//         x: clamp(pos.x, minX, maxX),
//         y: clamp(pos.y, minY, maxY)
//       }));
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Dropdown Notifications anchored to the icon */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: `${iconLeft}px`,
//             transform: "translateX(-100%)",
//             width: "90vw",
//             maxWidth: "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           {/* Header Section */}
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           {/* Notification List */}
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "12px",
//                           color: "#555",
//                           marginTop: "4px",
//                         }}
//                       >
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications anchored to the icon */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: `${iconLeft}px`,
//           transform: "translateX(-100%)",
//           zIndex: 9000,
//           width: "90vw",
//           maxWidth: "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;





















// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Refs to track drag state.
//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragStart = useRef({ x: 0, y: 0 });
//   const isDragging = useRef(false);
//   // Use a slightly higher threshold for touch interactions if needed.
//   const MOUSE_DRAG_THRESHOLD = 5;
//   const TOUCH_DRAG_THRESHOLD = 10;

//   // For touch timing (to differentiate tap from a long touch/drag).
//   const touchStartTime = useRef(0);

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Update dropdown position based on icon position.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Update localUserType if the user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // FETCH NOTIFICATIONS.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // SOCKET LISTENER for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;
//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;

//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }

//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };

//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }

//       setNotifications((prev) => [...prev, newNotif]);

//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   // Count of unseen notifications.
//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Mark all notifications as seen.
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   // Navigation handler when a notification is clicked.
//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };
//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   // Group notifications by ticket identifier.
//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // Helper function to clamp values.
//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // -------------
//   // DRAG & DROP HANDLERS
//   // -------------

//   // Mouse Events
//   const handleMouseDown = (e) => {
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > MOUSE_DRAG_THRESHOLD) {
//       isDragging.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!isDragging.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//   };

//   // Touch Events for Mobile Devices
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     const touch = e.touches[0];
//     touchStartTime.current = Date.now();
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > TOUCH_DRAG_THRESHOLD) {
//       isDragging.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     // Determine if this was a quick tap.
//     const touchDuration = Date.now() - touchStartTime.current;
//     if (!isDragging.current && touchDuration < 300) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//   };

//   // Update positions on window resize to keep the component in view.
//   useEffect(() => {
//     const handleResize = () => {
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition((pos) => ({
//         x: clamp(pos.x, minX, maxX),
//         y: clamp(pos.y, minY, maxY)
//       }));
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Dropdown Notifications anchored to the icon */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: `${iconLeft}px`,
//             transform: "translateX(-100%)",
//             width: "90vw",
//             maxWidth: "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           {/* Header Section */}
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           {/* Notification List */}
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications anchored to the icon */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: `${iconLeft}px`,
//           transform: "translateX(-100%)",
//           zIndex: 9000,
//           width: "90vw",
//           maxWidth: "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;























// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Refs to track drag state.
//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragStart = useRef({ x: 0, y: 0 });
//   // We'll use both isDragging and wasDragged for clarity.
//   const isDragging = useRef(false);
//   const wasDragged = useRef(false);
//   const MOUSE_DRAG_THRESHOLD = 5;
//   const TOUCH_DRAG_THRESHOLD = 15;

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Update dropdown position based on icon position.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Update localUserType if user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // FETCH NOTIFICATIONS.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // SOCKET LISTENER for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;
//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;

//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn(
//           "No ticket identifier found in notification payload:",
//           data
//         );
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }

//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };

//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }

//       setNotifications((prev) => [...prev, newNotif]);

//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   // Count of unseen notifications.
//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Mark all notifications as seen.
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   // Navigation handler when a notification is clicked.
//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };
//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   // Group notifications by ticket identifier.
//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // Helper function to clamp values.
//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // -------------
//   // DRAG & DROP HANDLERS
//   // -------------

//   // Mouse Events
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > MOUSE_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Touch Events for Mobile Devices
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > TOUCH_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Update positions on window resize to keep component in view.
//   useEffect(() => {
//     const handleResize = () => {
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition((pos) => ({
//         x: clamp(pos.x, minX, maxX),
//         y: clamp(pos.y, minY, maxY)
//       }));
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Dropdown Notifications anchored to the icon */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: `${iconLeft}px`,
//             transform: "translateX(-100%)",
//             width: "90vw",
//             maxWidth: "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           {/* Header Section */}
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           {/* Notification List */}
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications anchored to the icon */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: `${iconLeft}px`,
//           transform: "translateX(-100%)",
//           zIndex: 9000,
//           width: "90vw",
//           maxWidth: "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;











// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile based on window width (e.g., less than 600px)
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Update mobile state and recalc position on resize.
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition((pos) => ({
//         x: clamp(pos.x, minX, maxX),
//         y: clamp(pos.y, minY, maxY)
//       }));
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Refs to track drag state.
//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragStart = useRef({ x: 0, y: 0 });
//   const isDragging = useRef(false);
//   const wasDragged = useRef(false);
//   const MOUSE_DRAG_THRESHOLD = 5;
//   const TOUCH_DRAG_THRESHOLD = 15;

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Update dropdown position based on icon position.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Update localUserType if user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Fetch notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listener for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;
//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;
//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Mark all notifications as seen.
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // Helper function to clamp values.
//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // -------------
//   // DRAG & DROP HANDLERS
//   // -------------
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > MOUSE_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > TOUCH_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             // On mobile, align flush with the left side with a margin; on desktop, anchor to the icon.
//             left: isMobile ? "10px" : `${iconLeft}px`,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: isMobile ? "10px" : `${iconLeft}px`,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;














// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile based on window width (e.g., less than 600px)
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Update mobile state and recalc position on resize.
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition((pos) => ({
//         x: clamp(pos.x, minX, maxX),
//         y: clamp(pos.y, minY, maxY)
//       }));
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Refs to track drag state.
//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragStart = useRef({ x: 0, y: 0 });
//   const isDragging = useRef(false);
//   const wasDragged = useRef(false);
//   const MOUSE_DRAG_THRESHOLD = 5;
//   const TOUCH_DRAG_THRESHOLD = 15;

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Update dropdown position based on icon position.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Update localUserType if user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Fetch notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listener for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;
//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;
//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });



    
//   // NEW: Listen for ticket notifications
//     // socket.on("ticketNotification", (data) => {
//     //   // Ensure that the notification is intended for this user.
//     //   if (data.targetUserId !== userId) return;
//     //   const newNotif = {
//     //     _id: Date.now().toString(), // Ideally use a robust unique ID generator
//     //     message: data.message,
//     //     ticketId: data.ticketId,
//     //     from: data.from,
//     //     isSeen: false,
//     //     timestamp: new Date(data.timestamp),
//     //   };
//     //   try {
//     //     audioRef.current?.play();
//     //   } catch (e) {
//     //     console.warn("Unable to play sound:", e.message);
//     //   }
//     //   setNotifications((prev) => [...prev, newNotif]);
//     //   // Auto-mark popup notifications as seen after 6 seconds.
//     //   setTimeout(() => {
//     //     setNotifications((prev) =>
//     //       prev.map((n) =>
//     //         n._id === newNotif._id ? { ...n, isSeen: true } : n
//     //       )
//     //     );
//     //   }, 6000);
//     // });


// socket.on("ticketNotification", (data) => {
//   if (data.targetUserId !== userId) return;
//   const newNotif = {
//     _id: Date.now().toString(), // Use a more robust ID generator if available
//     message: data.message,
//     ticketId: data.ticketId,
//     from: data.from,
//     isSeen: false,
//     timestamp: new Date(data.timestamp),
//   };
//   try {
//     audioRef.current?.play();
//   } catch (e) {
//     console.warn("Unable to play sound:", e.message);
//   }
//   setNotifications((prev) => [...prev, newNotif]);
//   // Auto-mark popup notifications as seen after 6 seconds.
//   setTimeout(() => {
//     setNotifications((prev) =>
//       prev.map((n) =>
//         n._id === newNotif._id ? { ...n, isSeen: true } : n
//       )
//     );
//   }, 6000);
// });

    
    

//     return () => {
//       socket.off("chatNotification");
//        socket.off("ticketNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Mark all notifications as seen.
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//  const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//   const finalTicketId =
//     ticketIdFromNotif ||
//     getTicketId(notifications.find((n) => n._id === notifId) || {});
//   if (notifId) {
//     await handleMarkSeen(notifId);
//   }
//   if (!finalTicketId) {
//     console.error(
//       "No ticket identifier found for navigation. Notification details:",
//       notifications.find((n) => n._id === notifId)
//     );
//     return;
//   }
//   const userRole = localUserType ? localUserType.toLowerCase() : "client";
//   if (userRole === "manager" || userRole === "general manager") {
//     navigate(`/manager/${finalTicketId}`);
//   } else if (userRole === "client") {
//     navigate(`/client/${finalTicketId}`);
//   } else if (userRole === "tasker") {
//     navigate(`/tasker/${finalTicketId}`);
//   } else if (userRole === "implementer") {
//     navigate(`/implementer/${finalTicketId}`);
//   } else {
//     navigate(`/client/${finalTicketId}`);
//   }
// };


//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // Helper function to clamp values.
//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // -------------
//   // DRAG & DROP HANDLERS
//   // -------------
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > MOUSE_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > TOUCH_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             // On mobile, align flush with the left side with a margin; on desktop, anchor to the icon.
//             left: isMobile ? "10px" : `${iconLeft}px`,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: isMobile ? "10px" : `${iconLeft}px`,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;













// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile based on window width (e.g., less than 600px)
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Update mobile state and recalc position on resize.
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition((pos) => ({
//         x: Math.min(Math.max(pos.x, minX), maxX),
//         y: Math.min(Math.max(pos.y, minY), maxY)
//       }));
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Refs to track drag state.
//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const dragStart = useRef({ x: 0, y: 0 });
//   const isDragging = useRef(false);
//   const wasDragged = useRef(false);
//   const MOUSE_DRAG_THRESHOLD = 5;
//   const TOUCH_DRAG_THRESHOLD = 15;

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Update dropdown position based on icon position.
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Update localUserType if user context changes.
//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Fetch notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listener for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;
//     socket.emit("registerUser", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId !== userId) return;
//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       if (!receivedTicketId) {
//         console.warn("No ticket identifier found in notification payload:", data);
//       } else {
//         console.log("Extracted ticket identifier:", receivedTicketId);
//       }
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     // NEW: Listen for ticket notifications
//     socket.on("ticketNotification", (data) => {
//       // Compare using string conversion for reliable matching.
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const newNotif = {
//         _id: Date.now().toString(), // Use a robust unique ID generator if available.
//         message: data.message,
//         ticketId: data.ticketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(data.timestamp),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       // Auto-mark popup notifications as seen after 6 seconds.
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//       socket.off("ticketNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark an individual notification as seen.
//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // Mark all notifications as seen.
//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   // Helper function to clamp values.
//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // -------------
//   // DRAG & DROP HANDLERS
//   // -------------
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > MOUSE_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > TOUCH_DRAG_THRESHOLD) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: isMobile ? "10px" : `${iconLeft}px`,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: isMobile ? "10px" : `${iconLeft}px`,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;


















// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile based on window width.
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Update mobile state and recalc position on resize.
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY)
//       });
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // *** NEW: Add missing drag & drop refs ***
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   // *** END NEW ***

//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Fetch notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listener for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;

//     // Register the user.
//     socket.emit("registerUser", userId);
//     console.log("GlobalNotification: Registered user", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const receivedTicketId =
//         data.ticketId || data.ticketID || data.ticketNumber;
//       console.log("Chat notification received:", data, "for ticket:", receivedTicketId);
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Chat: Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     // Ticket notifications.
//     socket.on("ticketNotification", (data) => {
//       console.log("Received ticketNotification event:", data);
//       if (data.targetUserId.toString() !== userId.toString()) {
//         console.log("TicketNotification ignored. Target:", data.targetUserId, "Current:", userId);
//         return;
//       }
//       const newNotif = {
//         _id: Date.now().toString(), // In production, use a proper unique ID.
//         message: data.message,
//         ticketId: data.ticketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(data.timestamp),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Ticket: Unable to play sound:", e.message);
//       }
//       console.log("Notification added for ticket:", newNotif);
//       setNotifications((prev) => [...prev, newNotif]);
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//       socket.off("ticketNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // --- DRAG & DROP HANDLERS ---
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: isMobile ? "10px" : `${iconLeft}px`,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: isMobile ? "10px" : `${iconLeft}px`,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;













// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const isSocketSetup = useRef(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile based on window width.
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Update mobile state and recalc position on resize.
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY)
//       });
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // ** NEW: Refs for drag & drop state **
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   // ** END NEW **

//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Fetch stored notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listener for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded || isSocketSetup.current) return;
    
//     // Register the user.
//     socket.emit("registerUser", userId);
//     console.log("GlobalNotification: Registered user", userId);
//     isSocketSetup.current = true;

//     socket.on("chatNotification", (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const receivedTicketId = data.ticketId || data.ticketID || data.ticketNumber;
//       console.log("Chat notification received:", data, "for ticket:", receivedTicketId);
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Chat: Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     // Ticket notifications.
//     socket.on("ticketNotification", (data) => {
//       console.log("Received ticketNotification event:", data);
//       // If targetUserId is "@all" (ignore case), process for all users.
//       const target = data.targetUserId ? data.targetUserId.toString().toLowerCase() : "";
//       if (target !== "@all" && data.targetUserId.toString() !== userId.toString()) {
//         console.log("TicketNotification ignored. Target:", data.targetUserId, "Current:", userId);
//         return;
//       }
//       const newNotif = {
//         _id: Date.now().toString(), // In production, use a robust unique ID.
//         message: data.message,
//         ticketId: data.ticketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(data.timestamp),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Ticket: Unable to play sound:", e.message);
//       }
//       console.log("Notification added for ticket:", newNotif);
//       setNotifications((prev) => [...prev, newNotif]);
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     });

//     return () => {
//       socket.off("chatNotification");
//       socket.off("ticketNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   const handleMarkAllSeen = async () => {
//     const unseenNotifs = notifications.filter((n) => !n.isSeen);
//     try {
//       await Promise.all(
//         unseenNotifs.map((n) =>
//           fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//             method: "PATCH",
//             credentials: "include",
//           })
//         )
//       );
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // --- DRAG & DROP HANDLERS ---
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: isMobile ? "10px" : `${iconLeft}px`,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//             <button
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#eaeaea"
//                           : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = notif.isSeen
//                           ? "#f2f2f2"
//                           : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: isMobile ? "10px" : `${iconLeft}px`,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;














// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default position: 30px from top and 10px from right.
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile based on window width.
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       localStorage.setItem("notifPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Update mobile state and recalc position on resize.
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY)
//       });
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Refs for the draggable container and icon.
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // ** NEW: Refs for drag & drop state **
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   // ** END NEW **

//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   useEffect(() => {
//     if (user && (user.usertype || user.userType)) {
//       setLocalUserType(user.usertype || user.userType);
//     }
//   }, [user]);

//   // Fetch stored notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     const fetchNotifications = async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err.message);
//       }
//     };
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Updated: Socket listener for real-time notifications.
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     // Register the user.
//     socket.emit("registerUser", userId);
//     console.log("GlobalNotification: Registered user", userId);

//     const handleChatNotification = (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const receivedTicketId = data.ticketId || data.ticketID || data.ticketNumber;
//       console.log("Chat notification received:", data, "for ticket:", receivedTicketId);
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: receivedTicketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Chat: Unable to play sound:", e.message);
//       }
//       setNotifications((prev) => [...prev, newNotif]);
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     };

//     const handleTicketNotification = (data) => {
//       const target = data.targetUserId ? data.targetUserId.toString().toLowerCase() : "";
//       if (target !== "@all" && data.targetUserId.toString() !== userId.toString()) {
//         console.log("TicketNotification ignored. Target:", data.targetUserId, "Current:", userId);
//         return;
//       }
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: data.ticketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//       };
//       try {
//         audioRef.current?.play();
//       } catch (e) {
//         console.warn("Ticket: Unable to play sound:", e.message);
//       }
//       console.log("Notification added for ticket:", newNotif);
//       setNotifications((prev) => [...prev, newNotif]);
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     };


//     // NEW: When someone is added to a ticket, show a notification
//     const handleAssignmentNotification = (data) => {
//       // only for me or everyone
//       if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//       const newNotif = {
//         _id: Date.now().toString(),
//         message: data.message,
//         ticketId: data.ticketId,
//         from: data.from,
//         isSeen: false,
//         timestamp: new Date(data.timestamp),
//       };
//       try { audioRef.current?.play(); } catch { }
//       setNotifications((prev) => [...prev, newNotif]);
//       // auto‑mark popup seen
//       setTimeout(() => {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n._id === newNotif._id ? { ...n, isSeen: true } : n
//           )
//         );
//       }, 6000);
//     };



//     socket.on("chatNotification", handleChatNotification);
//     socket.on("ticketNotification", handleTicketNotification);
//     socket.on("userAddedNotification", handleAssignmentNotification);

//     return () => {
//       socket.off("chatNotification", handleChatNotification);
//       socket.off("ticketNotification", handleTicketNotification);
//       socket.off("userAddedNotification", handleAssignmentNotification);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   const handleMarkSeen = async (notifId) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${notifId}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === notifId ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err.message);
//     }
//   };

//   // const handleMarkAllSeen = async () => {
//   //   const unseenNotifs = notifications.filter((n) => !n.isSeen);
//   //   try {
//   //     await Promise.all(
//   //       unseenNotifs.map((n) =>
//   //         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//   //           method: "PATCH",
//   //           credentials: "include",
//   //         })
//   //       )
//   //     );

//     const handleMarkAllSeen = () => {
//    setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//    notifications
//      .filter((n) => !n.isSeen)
//      .forEach((n) => {
//        fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//          method: "PATCH",
//          credentials: "include",
//        }).catch((err) =>
//          console.error(`Failed to mark notification ${n._id} as seen:`, err)
//        );
//      });
// };
//       setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
//     } catch (err) {
//       console.error("Mark all seen failed:", err.message);
//     }
//   };

//   const getTicketId = (notif) => {
//     return notif.ticketId || notif.ticketID || notif.ticketNumber;
//   };

//   const handleNavigateToTicket = async (ticketIdFromNotif, notifId) => {
//     const finalTicketId =
//       ticketIdFromNotif ||
//       getTicketId(notifications.find((n) => n._id === notifId) || {});
//     if (notifId) {
//       await handleMarkSeen(notifId);
//     }
//     if (!finalTicketId) {
//       console.error(
//         "No ticket identifier found for navigation. Notification details:",
//         notifications.find((n) => n._id === notifId)
//       );
//       return;
//     }
//     const userRole = localUserType ? localUserType.toLowerCase() : "client";
//     if (userRole === "manager" || userRole === "general manager") {
//       navigate(`/manager/${finalTicketId}`);
//     } else if (userRole === "client") {
//       navigate(`/client/${finalTicketId}`);
//     } else if (userRole === "tasker") {
//       navigate(`/tasker/${finalTicketId}`);
//     } else if (userRole === "implementer") {
//       navigate(`/implementer/${finalTicketId}`);
//     } else {
//       navigate(`/client/${finalTicketId}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, notif) => {
//     const groupKey = getTicketId(notif) || "other";
//     acc[groupKey] = acc[groupKey] || [];
//     acc[groupKey].push(notif);
//     return acc;
//   }, {});

//   const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

//   // --- DRAG & DROP HANDLERS ---
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const deltaX = e.clientX - dragStart.current.x;
//     const deltaY = e.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const touch = e.touches[0];
//     dragStart.current = { x: touch.clientX, y: touch.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const touch = e.touches[0];
//     const deltaX = touch.clientX - dragStart.current.x;
//     const deltaY = touch.clientY - dragStart.current.y;
//     const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//     if (!isDragging.current && distance > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const containerWidth = notifRef.current ? notifRef.current.offsetWidth : 50;
//       const containerHeight = notifRef.current ? notifRef.current.offsetHeight : 50;
//       const minX = 10;
//       const minY = 30;
//       const maxX = window.innerWidth - containerWidth - 10;
//       const maxY = window.innerHeight - containerHeight - 10;
//       const newX = clamp(touch.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(touch.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) {
//       setShowDropdown((prev) => !prev);
//     }
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   return (
//     <>
//       {/* Draggable Notification Icon Container */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           zIndex: 10000,
//           cursor: "move",
//           userSelect: "none",
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: "20px",
//             background: "none",
//             border: "none",
//             cursor: "pointer",
//             position: "relative",
//             outline: "none",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-6px",
//                 right: "-6px",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "11px",
//                 width: "16px",
//                 height: "16px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: `${notificationsTop}px`,
//             left: isMobile ? "10px" : `${iconLeft}px`,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : "400px",
//             background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
//             borderRadius: "12px",
//             zIndex: 10000,
//             padding: "15px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: "10px" }}>
//             <strong style={{ fontSize: "16px" }}>Notifications</strong>
//            <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 fontSize: "12px",
//                 border: "none",
//                 background: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: "4px",
//                 right: "4px",
//                 background: "transparent",
//                 border: "none",
//                 fontSize: "12px",
//                 color: "#888",
//                 cursor: "pointer",
//                 padding: "2px",
//               }}
//               aria-label="Close notifications"
//             >
//               &#10006;
//             </button>
//           </div>
//           <div style={{ maxHeight: "240px", overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.keys(grouped).map((groupKey) => (
//               <div key={groupKey} style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     marginBottom: "6px",
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: "4px",
//                   }}
//                 >
//                   {groupKey !== "other" ? `Ticket: ${groupKey}` : "General"}
//                 </div>
//                 {grouped[groupKey].map((notif) => {
//                   const ticketIdentifier = getTicketId(notif);
//                   return (
//                     <div
//                       key={notif._id}
//                       onClick={() =>
//                         handleNavigateToTicket(ticketIdentifier, notif._id)
//                       }
//                       style={{
//                         padding: "12px",
//                         marginBottom: "8px",
//                         borderRadius: "8px",
//                         backgroundColor: notif.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: "15px",
//                         transition: "background 0.3s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                       (e.currentTarget.style.backgroundColor = notif.isSeen
//                         ? "#eaeaea"
//                         : "#c7e7ff")
//                       }
//                       onMouseLeave={(e) =>
//                       (e.currentTarget.style.backgroundColor = notif.isSeen
//                         ? "#f2f2f2"
//                         : "#dff4ff")
//                       }
//                     >
//                       {notif.message}
//                       <div
//                         style={{
//                           color: "#555",
//                           fontStyle: "italic",
//                           textDecoration: "underline",
//                           marginTop: "4px",
//                           fontSize: "13px",
//                         }}
//                       >
//                         Ticket: {ticketIdentifier || "N/A"}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
//                         {new Date(notif.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: `${notificationsTop}px`,
//           left: isMobile ? "10px" : `${iconLeft}px`,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : "380px",
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: "10px",
//                 borderRadius: "10px",
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: "15px",
//                 transition: "opacity 0.3s ease",
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;






// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // draggable icon position
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // resize handler for isMobile and reposition constraints
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // refs and dropdown positioning
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // drag state
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   // update dropdown position when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // sync localUserType
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // fetch persisted notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     (async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, { credentials: "include" });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err);
//       }
//     })();
//   }, [userId, isUserLoaded]);

//   // socket listeners
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); }
//       catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

//     const chatHandler = (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     const ticketHandler = (data) => {
//       const t = data.targetUserId?.toString().toLowerCase();
//       if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     const assignmentHandler = (data) => {
//       if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", chatHandler);
//     socket.on("ticketNotification", ticketHandler);
//     socket.on("userAddedNotification", assignmentHandler);
//     return () => {
//       socket.off("chatNotification", chatHandler);
//       socket.off("ticketNotification", ticketHandler);
//       socket.off("userAddedNotification", assignmentHandler);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // <------ FIXED handleMarkAllSeen ------->
//   const handleMarkAllSeen = () => {
//     // optimistic UI
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     // background PATCHes
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) =>
//           console.error(`Failed to mark ${n._id} seen:`, e)
//         )
//       );
//   };
//   // ----------------------------------------

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     if (nid) await handleMarkSeen(nid);
//     const final = tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID");
//     const role = localUserType?.toLowerCase() || "client";
//     navigate(
//       role === "manager" || role === "general manager"
//         ? `/manager/${final}`
//         : role === "tasker"
//         ? `/tasker/${final}`
//         : role === "implementer"
//         ? `/implementer/${final}`
//         : `/client/${final}`
//     );
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   // DRAG & DROP handlers (unchanged) ...
//   // [handleMouseDown, handleMouseMove, handleMouseUp,
//   //  handleTouchStart, handleTouchMove, handleTouchEnd]

//   // -- RENDER --
//   return (
//     <>
//       {/* draggable icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.keys(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.entries(grouped).map(([key, list]) => (
//               <div key={key} style={{ marginBottom: 12 }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: 14,
//                     marginBottom: 6,
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: 4,
//                   }}
//                 >
//                   {key !== "other" ? `Ticket: ${key}` : "General"}
//                 </div>
//                 {list.map((n) => {
//                   const tid = getTicketId(n);
//                   return (
//                     <div
//                       key={n._id}
//                       onClick={() => handleNavigateToTicket(tid, n._id)}
//                       style={{
//                         padding: 12,
//                         marginBottom: 8,
//                         borderRadius: 8,
//                         backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: 15,
//                       }}
//                     >
//                       {n.message}
//                       <div
//                         style={{
//                           fontSize: 13,
//                           fontStyle: "italic",
//                           marginTop: 4,
//                           color: "#555",
//                           textDecoration: "underline",
//                         }}
//                       >
//                         Ticket: {tid || "N/A"}
//                       </div>
//                       <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
//                         {new Date(n.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* small popups */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;






// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Default draggable icon position
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Determine if mobile view
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   // Persist position to localStorage
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Handle window resize: update isMobile and clamp position
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Refs for positioning the dropdown
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Drag & drop state refs
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   // Update dropdown position whenever icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Sync localUserType when user changes
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Fetch persisted notifications from backend
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     (async () => {
//       try {
//         const res = await fetch(`${backendUrl}/notifications`, {
//           credentials: "include",
//         });
//         const data = await res.json();
//         if (res.ok && data.notifications) {
//           setNotifications(data.notifications);
//         }
//       } catch (err) {
//         console.error("Error fetching notifications:", err);
//       }
//     })();
//   }, [userId, isUserLoaded]);

//   // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); }
//       catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

//     const chatHandler = (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     const ticketHandler = (data) => {
//       const t = data.targetUserId?.toString().toLowerCase();
//       if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     const assignmentHandler = (data) => {
//       if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", chatHandler);
//     socket.on("ticketNotification", ticketHandler);
//     socket.on("userAddedNotification", assignmentHandler);

//     return () => {
//       socket.off("chatNotification", chatHandler);
//       socket.off("ticketNotification", ticketHandler);
//       socket.off("userAddedNotification", assignmentHandler);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // <------ FIXED handleMarkAllSeen ------->
//   const handleMarkAllSeen = () => {
//     // 1) update UI immediately
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     // 2) send background PATCH requests
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) =>
//           console.error(`Failed to mark ${n._id} seen:`, e)
//         )
//       );
//   };
//   // ----------------------------------------

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     if (nid) await handleMarkSeen(nid);
//     const final = tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) {
//       console.error("No ticket ID for navigation");
//       return;
//     }
//     const role = localUserType?.toLowerCase() || "client";
//     if (role === "manager" || role === "general manager") {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   // --- DRAG & DROP HANDLERS ---
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     const dist = Math.sqrt(dx * dx + dy * dy);
//     if (!isDragging.current && dist > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: t.clientX - position.x,
//       y: t.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     const dist = Math.sqrt(dx * dx + dy * dy);
//     if (!isDragging.current && dist > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       const newX = clamp(t.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(t.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   // --- END DRAG & DROP HANDLERS ---

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => setShowDropdown(false)}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.entries(grouped).map(([key, list]) => (
//               <div key={key} style={{ marginBottom: 12 }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: 14,
//                     marginBottom: 6,
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: 4,
//                   }}
//                 >
//                   {key !== "other" ? `Ticket: ${key}` : "General"}
//                 </div>
//                 {list.map((n) => {
//                   const tid = getTicketId(n);
//                   return (
//                     <div
//                       key={n._id}
//                       onClick={() => handleNavigateToTicket(tid, n._id)}
//                       style={{
//                         padding: 12,
//                         marginBottom: 8,
//                         borderRadius: 8,
//                         backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: 15,
//                       }}
//                     >
//                       {n.message}
//                       <div
//                         style={{
//                           fontSize: 13,
//                           fontStyle: "italic",
//                           marginTop: 4,
//                           color: "#555",
//                           textDecoration: "underline",
//                         }}
//                       >
//                         Ticket: {tid || "N/A"}
//                       </div>
//                       <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
//                         {new Date(n.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;













// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // // Default draggable icon position
//   // const [position, setPosition] = useState(() => {
//   //   if (typeof window !== "undefined") {
//   //     const saved = localStorage.getItem("notifPosition");
//   //     if (saved) return JSON.parse(saved);
//   //     return { x: window.innerWidth - 50, y: 30 };
//   //   }
//   //   return { x: 300, y: 30 };
//   // });

  


// // CHANGE: Persisted position for draggable icon
// const [position, setPosition] = useState(() => {
//   if (typeof window !== "undefined") {
//     const saved = localStorage.getItem("notifPosition");
//     if (saved) return JSON.parse(saved);
//     return { x: window.innerWidth - 50, y: 30 };
//   }
//   return { x: 300, y: 30 };
// });

// // CHANGE: refs & state to track dropdown placement
// const notifRef = useRef(null);
// const iconRef = useRef(null);
// const [notificationsTop, setNotificationsTop] = useState(0);
// const [iconLeft, setIconLeft] = useState(0);

// // CHANGE: Remove duplicate icons on mount
// useEffect(() => {
//   const all = document.querySelectorAll("#global-notif-icon"); // CHANGE:
//   if (all.length > 1) {
//     all.forEach((el, i) => {
//       if (i < all.length - 1) el.remove(); // keep only last
//     });
//   }
// }, []);

// // CHANGE: save position
// useEffect(() => {
//   localStorage.setItem("notifPosition", JSON.stringify(position));
// }, [position]);

// // CHANGE: update dropdown coords
// useEffect(() => {
//   if (iconRef.current) {
//     const rect = iconRef.current.getBoundingClientRect();
//     setNotificationsTop(rect.bottom + 8);
//     setIconLeft(rect.left);
//   }
// }, [position]);






//   // Determine if mobile view
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );

//   // Persist position to localStorage
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Handle window resize: update isMobile and clamp position
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // // Refs for positioning the dropdown
//   // const notifRef = useRef(null);
//   // const iconRef = useRef(null);
//   // const [notificationsTop, setNotificationsTop] = useState(0);
//   // const [iconLeft, setIconLeft] = useState(0);

//   // Drag & drop state refs
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   // Update dropdown position whenever icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Sync localUserType when user changes
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // // Fetch persisted notifications from backend
//   // useEffect(() => {
//   //   if (!userId || !isUserLoaded) return;
//   //   (async () => {
//   //     try {
//   //       const res = await fetch(`${backendUrl}/notifications`, {
//   //         credentials: "include",
//   //       });
//   //       const data = await res.json();
//   //       if (res.ok && data.notifications) {
//   //         setNotifications(data.notifications);
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching notifications:", err);
//   //     }
//   //   })();
//   // }, [userId, isUserLoaded]);

//     // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); }
//       catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

//     const chatHandler = (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     const ticketHandler = (data) => {
//       const t = data.targetUserId?.toString().toLowerCase();
//       if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     const assignmentHandler = (data) => {
//       if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", chatHandler);
//     socket.on("ticketNotification", ticketHandler);
//     socket.on("userAddedNotification", assignmentHandler);

//     return () => {
//       socket.off("chatNotification", chatHandler);
//       socket.off("ticketNotification", ticketHandler);
//       socket.off("userAddedNotification", assignmentHandler);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // <------ FIXED handleMarkAllSeen ------->
//   const handleMarkAllSeen = () => {
//     // 1) update UI immediately
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     // 2) send background PATCH requests
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) =>
//           console.error(`Failed to mark ${n._id} seen:`, e)
//         )
//       );
//   };
//   // ----------------------------------------

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false); 
//     if (nid) await handleMarkSeen(nid);
//     const final = tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) {
//       console.error("No ticket ID for navigation");
//       return;
//     }
//     const role = localUserType?.toLowerCase() || "client";
//     if (role === "manager" || role === "general manager") {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   // --- DRAG & DROP HANDLERS ---
//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     const dist = Math.sqrt(dx * dx + dy * dy);
//     if (!isDragging.current && dist > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       const newX = clamp(e.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(e.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = {
//       x: t.clientX - position.x,
//       y: t.clientY - position.y,
//     };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     const dist = Math.sqrt(dx * dx + dy * dy);
//     if (!isDragging.current && dist > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       const newX = clamp(t.clientX - dragOffset.current.x, minX, maxX);
//       const newY = clamp(t.clientY - dragOffset.current.y, minY, maxY);
//       setPosition({ x: newX, y: newY });
//     }
//   };

//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   // --- END DRAG & DROP HANDLERS ---

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
// {/*               onClick={() => setShowDropdown(false)} */}
//                onClick={() => {
//                               setShowDropdown(false);
//                               fetchNotifications();
//                             }}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 && (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             )}
//             {Object.entries(grouped).map(([key, list]) => (
//               <div key={key} style={{ marginBottom: 12 }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: 14,
//                     marginBottom: 6,
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: 4,
//                   }}
//                 >
//                   {key !== "other" ? `Ticket: ${key}` : "General"}
//                 </div>
//                 {list.map((n) => {
//                   const tid = getTicketId(n);
//                   return (
//                     <div
//                       key={n._id}
//                       onClick={() => handleNavigateToTicket(tid, n._id)}
//                       style={{
//                         padding: 12,
//                         marginBottom: 8,
//                         borderRadius: 8,
//                         backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: 15,
//                       }}
//                     >
//                       {n.message}
//                       <div
//                         style={{
//                           fontSize: 13,
//                           fontStyle: "italic",
//                           marginTop: 4,
//                           color: "#555",
//                           textDecoration: "underline",
//                         }}
//                       >
//                         Ticket: {tid || "N/A"}
//                       </div>
//                       <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
//                         {new Date(n.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;











// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Persisted position for draggable icon
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Refs & state to track dropdown placement
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Remove duplicate icons on mount
//   useEffect(() => {
//     const all = document.querySelectorAll("#global-notif-icon");
//     if (all.length > 1) {
//       all.forEach((el, i) => {
//         if (i < all.length - 1) el.remove();
//       });
//     }
//   }, []);

//   // Save position
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Update dropdown coords when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Mobile detection & resizing
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       // clamp within viewport
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Drag & drop handlers...
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };
//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Sync user type
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     // join user‐specific room
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); } catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

//     const chatHandler = (data) => {
//       if (data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };
//     const ticketHandler = (data) => {
//       const t = data.targetUserId?.toString().toLowerCase();
//       if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };
//     const assignmentHandler = (data) => {
//       if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//       const n = makeNotif(data);
//       playSound();
//       setNotifications((p) => [...p, n]);
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", chatHandler);
//     socket.on("ticketNotification", ticketHandler);
//     socket.on("userAddedNotification", assignmentHandler);

//     return () => {
//       socket.off("chatNotification", chatHandler);
//       socket.off("ticketNotification", ticketHandler);
//       socket.off("userAddedNotification", assignmentHandler);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // Mark all as seen
//   const handleMarkAllSeen = () => {
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
//       );
//   };

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false);
//     if (nid) await handleMarkSeen(nid);
//     fetchNotifications();       // <— refresh after closing
//     const final =
//       tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID for navigation");
//     const role = localUserType?.toLowerCase() || "client";
//     if (["manager", "general manager"].includes(role)) {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           id="global-notif-icon"
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => {
//                 setShowDropdown(false);
//                 fetchNotifications();
//               }}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 ? (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             ) : (
//               Object.entries(grouped).map(([key, list]) => (
//                 <div key={key} style={{ marginBottom: 12 }}>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       fontSize: 14,
//                       marginBottom: 6,
//                       borderBottom: "1px solid #ddd",
//                       paddingBottom: 4,
//                     }}
//                   >
//                     {key !== "other" ? `Ticket: ${key}` : "General"}
//                   </div>
//                   {list.map((n) => {
//                     const tid = getTicketId(n);
//                     return (
//                       <div
//                         key={n._id}
//                         onClick={() => handleNavigateToTicket(tid, n._id)}
//                         style={{
//                           padding: 12,
//                           marginBottom: 8,
//                           borderRadius: 8,
//                           backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                           cursor: "pointer",
//                           fontSize: 15,
//                         }}
//                       >
//                         {n.message}
//                         <div
//                           style={{
//                             fontSize: 13,
//                             fontStyle: "italic",
//                             marginTop: 4,
//                             color: "#555",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           Ticket: {tid || "N/A"}
//                         </div>
//                         <div
//                           style={{ fontSize: 12, color: "#555", marginTop: 4 }}
//                         >
//                           {new Date(n.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;















// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Persisted position for draggable icon
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Refs & state to track dropdown placement
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Remove duplicate icons on mount
//   useEffect(() => {
//     const all = document.querySelectorAll("#global-notif-icon");
//     if (all.length > 1) {
//       all.forEach((el, i) => {
//         if (i < all.length - 1) el.remove();
//       });
//     }
//   }, []);

//   // Save position
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Update dropdown coords when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Mobile detection & resizing
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       // clamp within viewport
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Drag & drop handlers...
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };
//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Sync user type
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     // join user‐specific room
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); } catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

//     const chatHandler = (data) => {
//     //   if (data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//     //   setNotifications((p) => [...p, n]);
//     fetchNotifications();
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };
//     const ticketHandler = (data) => {
//     //   const t = data.targetUserId?.toString().toLowerCase();
//     const t = data.targetUserId ? data.targetUserId.toString().toLowerCase() : null;
//       if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//       const n = makeNotif(data);
//       playSound();
//     //   setNotifications((p) => [...p, n]);
//     fetchNotifications();
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };
//     const assignmentHandler = (data) => {
//     //   if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//     if (!data.targetUserId || (data.targetUserId !== userId && data.targetUserId !== "@all")) return;
//       const n = makeNotif(data);
//       playSound();
//     //   setNotifications((p) => [...p, n]);
//     fetchNotifications();
//       setTimeout(() => {
//         setNotifications((p) =>
//           p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", chatHandler);
//     socket.on("ticketNotification", ticketHandler);
//     socket.on("userAddedNotification", assignmentHandler);

//     return () => {
//       socket.off("chatNotification", chatHandler);
//       socket.off("ticketNotification", ticketHandler);
//       socket.off("userAddedNotification", assignmentHandler);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // Mark all as seen
//   const handleMarkAllSeen = () => {
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
//       );
//   };

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false);
//     if (nid) await handleMarkSeen(nid);
//     fetchNotifications();       // <— refresh after closing
//     const final =
//       tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID for navigation");
//     const role = localUserType?.toLowerCase() || "client";
//     if (["manager", "general manager"].includes(role)) {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           id="global-notif-icon"
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => {
//                 setShowDropdown(false);
//                 fetchNotifications();
//               }}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 ? (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             ) : (
//               Object.entries(grouped).map(([key, list]) => (
//                 <div key={key} style={{ marginBottom: 12 }}>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       fontSize: 14,
//                       marginBottom: 6,
//                       borderBottom: "1px solid #ddd",
//                       paddingBottom: 4,
//                     }}
//                   >
//                     {key !== "other" ? `Ticket: ${key}` : "General"}
//                   </div>
//                   {list.map((n) => {
//                     const tid = getTicketId(n);
//                     return (
//                       <div
//                         key={n._id}
//                         onClick={() => handleNavigateToTicket(tid, n._id)}
//                         style={{
//                           padding: 12,
//                           marginBottom: 8,
//                           borderRadius: 8,
//                           backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                           cursor: "pointer",
//                           fontSize: 15,
//                         }}
//                       >
//                         {n.message}
//                         <div
//                           style={{
//                             fontSize: 13,
//                             fontStyle: "italic",
//                             marginTop: 4,
//                             color: "#555",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           Ticket: {tid || "N/A"}
//                         </div>
//                         <div
//                           style={{ fontSize: 12, color: "#555", marginTop: 4 }}
//                         >
//                           {new Date(n.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;









// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Persisted position for draggable icon
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Refs & state to track dropdown placement
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Remove duplicate icons on mount
//   useEffect(() => {
//     const all = document.querySelectorAll("#global-notif-icon");
//     if (all.length > 1) {
//       all.forEach((el, i) => {
//         if (i < all.length - 1) el.remove();
//       });
//     }
//   }, []);

//   // Save position
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Update dropdown coords when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Mobile detection & resizing
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       // clamp within viewport
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Drag & drop handlers...
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };
//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Sync user type
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     // join user‐specific room
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); } catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

//     const chatHandler = (data) => {
//     // //   if (data.targetUserId.toString() !== userId.toString()) return;
//     //   const n = makeNotif(data);
//     //   playSound();
//     // //   setNotifications((p) => [...p, n]);
//     // fetchNotifications();
//     //   setTimeout(() => {
//     //     setNotifications((p) =>
//     //       p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//     //     );
//     //   }, 6000);
//     // };

//          if (data.targetUserId.toString() !== userId.toString()) return;
//         const n = makeNotif(data);
//         playSound();
//         // prepend the new notification
//         setNotifications((p) => [n, ...p]);
//         // optionally auto-mark as seen after a delay
//         setTimeout(() => {
//           setNotifications((p) =>
//             p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//           );
//         }, 6000);
//       };
        
//     // const ticketHandler = (data) => {
//     // //   const t = data.targetUserId?.toString().toLowerCase();
//     // const t = data.targetUserId ? data.targetUserId.toString().toLowerCase() : null;
//     //   if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//     //   const n = makeNotif(data);
//     //   playSound();
//     // //   setNotifications((p) => [...p, n]);
//     // fetchNotifications();
//     //   setTimeout(() => {
//     //     setNotifications((p) =>
//     //       p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//     //     );
//     //   }, 6000);
//     // };
// const ticketHandler = (data) => {
//         const target = data.targetUserId?.toString().toLowerCase();
//         if (target !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//         const n = makeNotif(data);
//         playSound();
//         setNotifications((p) => [n, ...p]);
//         setTimeout(() => {
//           setNotifications((p) =>
//             p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//           );
//         }, 6000);
//       };
        
//     // const assignmentHandler = (data) => {
//     // //   if (data.targetUserId !== userId && data.targetUserId !== "@all") return;
//     // if (!data.targetUserId || (data.targetUserId !== userId && data.targetUserId !== "@all")) return;
//     //   const n = makeNotif(data);
//     //   playSound();
//     // //   setNotifications((p) => [...p, n]);
//     // fetchNotifications();
//     //   setTimeout(() => {
//     //     setNotifications((p) =>
//     //       p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//     //     );
//     //   }, 6000);
//     // };

//          const assignmentHandler = (data) => {
//         if (
//           !data.targetUserId ||
//           (data.targetUserId !== userId && data.targetUserId !== "@all")
//         )
//           return;
//         const n = makeNotif(data);
//         playSound();
//         setNotifications((p) => [n, ...p]);
//         setTimeout(() => {
//           setNotifications((p) =>
//             p.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//           );
//         }, 6000);
//       };

//     socket.on("chatNotification", chatHandler);
//     socket.on("ticketNotification", ticketHandler);
//     socket.on("userAddedNotification", assignmentHandler);

//     return () => {
//       socket.off("chatNotification", chatHandler);
//       socket.off("ticketNotification", ticketHandler);
//       socket.off("userAddedNotification", assignmentHandler);
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // Mark all as seen
//   const handleMarkAllSeen = () => {
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
//       );
//   };

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false);
//     if (nid) await handleMarkSeen(nid);
//     fetchNotifications();       // <— refresh after closing
//     const final =
//       tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID for navigation");
//     const role = localUserType?.toLowerCase() || "client";
//     if (["manager", "general manager"].includes(role)) {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           id="global-notif-icon"
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => {
//                 setShowDropdown(false);
//                 fetchNotifications();
//               }}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 ? (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             ) : (
//               Object.entries(grouped).map(([key, list]) => (
//                 <div key={key} style={{ marginBottom: 12 }}>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       fontSize: 14,
//                       marginBottom: 6,
//                       borderBottom: "1px solid #ddd",
//                       paddingBottom: 4,
//                     }}
//                   >
//                     {key !== "other" ? `Ticket: ${key}` : "General"}
//                   </div>
//                   {list.map((n) => {
//                     const tid = getTicketId(n);
//                     return (
//                       <div
//                         key={n._id}
//                         onClick={() => handleNavigateToTicket(tid, n._id)}
//                         style={{
//                           padding: 12,
//                           marginBottom: 8,
//                           borderRadius: 8,
//                           backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                           cursor: "pointer",
//                           fontSize: 15,
//                         }}
//                       >
//                         {n.message}
//                         <div
//                           style={{
//                             fontSize: 13,
//                             fontStyle: "italic",
//                             marginTop: 4,
//                             color: "#555",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           Ticket: {tid || "N/A"}
//                         </div>
//                         <div
//                           style={{ fontSize: 12, color: "#555", marginTop: 4 }}
//                         >
//                           {new Date(n.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;





















// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));

//   // Persisted position for draggable icon
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Refs & state to track dropdown placement
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Remove duplicate icons on mount
//   useEffect(() => {
//     const all = document.querySelectorAll("#global-notif-icon");
//     if (all.length > 1) {
//       all.forEach((el, i) => {
//         if (i < all.length - 1) el.remove();
//       });
//     }
//   }, []);

//   // Save position
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Update dropdown coords when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Mobile detection & resizing
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       // clamp within viewport
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Drag & drop handlers...
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };
//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Sync user type
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;

//     // join user‐specific room
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); } catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//     });

// const chatHandler = (data) => {
//     if (data.targetUserId.toString() !== userId.toString()) return;
//     const n = makeNotif(data);
//     playSound();
//     setNotifications((prev) => [n, ...prev]);
//     // auto-mark seen after a delay
//     setTimeout(() => {
//       setNotifications((prev) =>
//         prev.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//       );
//     }, 6000);
//   };

//   const ticketHandler = (data) => {
//     const t = data.targetUserId?.toString().toLowerCase();
//     if (t !== "@all" && data.targetUserId.toString() !== userId.toString()) return;
//     const n = makeNotif(data);
//     playSound();
//     setNotifications((prev) => [n, ...prev]);
//     setTimeout(() => {
//       setNotifications((prev) =>
//         prev.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//       );
//     }, 6000);
//   };

//   const assignmentHandler = (data) => {
//     if (!data.targetUserId || (data.targetUserId !== userId && data.targetUserId !== "@all")) return;
//     const n = makeNotif(data);
//     playSound();
//     setNotifications((prev) => [n, ...prev]);
//     setTimeout(() => {
//       setNotifications((prev) =>
//         prev.map((x) => (x._id === n._id ? { ...x, isSeen: true } : x))
//       );
//     }, 6000);
//   };

//   socket.on("chatNotification", chatHandler);
//   socket.on("ticketNotification", ticketHandler);
//   socket.on("userAddedNotification", assignmentHandler);

//   return () => {
//     socket.off("chatNotification", chatHandler);
//     socket.off("ticketNotification", ticketHandler);
//     socket.off("userAddedNotification", assignmentHandler);
//   };
// }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // Mark all as seen
//   const handleMarkAllSeen = () => {
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
//       );
//   };

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false);
//     if (nid) await handleMarkSeen(nid);
//     fetchNotifications();       // <— refresh after closing
//     const final =
//       tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID for navigation");
//     const role = localUserType?.toLowerCase() || "client";
//     if (["manager", "general manager"].includes(role)) {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           id="global-notif-icon"
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => {
//                 setShowDropdown(false);
//                 fetchNotifications();
//               }}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 ? (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             ) : (
//               Object.entries(grouped).map(([key, list]) => (
//                 <div key={key} style={{ marginBottom: 12 }}>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       fontSize: 14,
//                       marginBottom: 6,
//                       borderBottom: "1px solid #ddd",
//                       paddingBottom: 4,
//                     }}
//                   >
//                     {key !== "other" ? `Ticket: ${key}` : "General"}
//                   </div>
//                   {list.map((n) => {
//                     const tid = getTicketId(n);
//                     return (
//                       <div
//                         key={n._id}
//                         onClick={() => handleNavigateToTicket(tid, n._id)}
//                         style={{
//                           padding: 12,
//                           marginBottom: 8,
//                           borderRadius: 8,
//                           backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                           cursor: "pointer",
//                           fontSize: 15,
//                         }}
//                       >
//                         {n.message}
//                         <div
//                           style={{
//                             fontSize: 13,
//                             fontStyle: "italic",
//                             marginTop: 4,
//                             color: "#555",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           Ticket: {tid || "N/A"}
//                         </div>
//                         <div
//                           style={{ fontSize: 12, color: "#555", marginTop: 4 }}
//                         >
//                           {new Date(n.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;















// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";
// import notificationSound from "./notification-sound.mp3";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const isApprovedManager = localUserType === 'manager' ? user?.approved === true : true;
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
// //   const audioRef = useRef(new Audio("/notification-sound.mp3"));
// const audioRef = useRef(new Audio(notificationSound));

//   // Persisted position for draggable icon
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Refs & state to track dropdown placement
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Remove duplicate icons on mount
//   useEffect(() => {
//     const all = document.querySelectorAll("#global-notif-icon");
//     if (all.length > 1) {
//       all.forEach((el, i) => {
//         if (i < all.length - 1) el.remove();
//       });
//     }
//   }, []);

//   // Save position
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Update dropdown coords when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Mobile detection & resizing
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       // clamp within viewport
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Drag & drop handlers...
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };
//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Sync user type
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//   // // Socket listeners for real-time notifications
//   // useEffect(() => {
//   //   if (!userId || !isUserLoaded) return;
  
//   //   socket.emit("registerUser", userId);
  
//   //   const playSound = () => {
//   //     try { audioRef.current.play(); } catch {}
//   //   };
  
//   //   const makeNotif = (data) => ({
//   //     _id: Date.now().toString(),
//   //     message: data.message,
//   //     ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//   //     from: data.from,
//   //     isSeen: false,
//   //     timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
//   //   });
  
//   //   const chatHandler = (data) => {
//   //     // only process if this notification is actually for me
//   //     if (!data.targetUserId || data.targetUserId.toString() !== userId.toString()) {
//   //       return;
//   //     }
//   //     const n = makeNotif(data);
//   //     playSound();
//   //     // prepend to our list immediately
//   //     setNotifications(prev => [n, ...prev]);
//   //     // then auto-mark seen after a delay
//   //     setTimeout(() => {
//   //       setNotifications(prev =>
//   //         prev.map(x => x._id === n._id ? { ...x, isSeen: true } : x)
//   //       );
//   //     }, 6000);
//   //   };
  
//   //   const ticketHandler = (data) => {
//   //     const tgt = data.targetUserId?.toString();
//   //     if (tgt !== "@all" && tgt !== userId.toString()) return;
//   //     const n = makeNotif(data);
//   //     playSound();
//   //     setNotifications(prev => [n, ...prev]);
//   //     setTimeout(() => {
//   //       setNotifications(prev =>
//   //         prev.map(x => x._id === n._id ? { ...x, isSeen: true } : x)
//   //       );
//   //     }, 6000);
//   //   };
  
//   //   const assignmentHandler = (data) => {
//   //     const tgt = data.targetUserId?.toString();
//   //     if (!tgt || (tgt !== userId.toString() && tgt !== "@all")) return;
//   //     const n = makeNotif(data);
//   //     playSound();
//   //     setNotifications(prev => [n, ...prev]);
//   //     setTimeout(() => {
//   //       setNotifications(prev =>
//   //         prev.map(x => x._id === n._id ? { ...x, isSeen: true } : x)
//   //       );
//   //     }, 6000);
//   //   };
  
//   //   socket.on("chatNotification", chatHandler);
//   //   socket.on("ticketNotification", ticketHandler);
//   //   socket.on("userAddedNotification", assignmentHandler);
  
//   //   return () => {
//   //     socket.off("chatNotification", chatHandler);
//   //     socket.off("ticketNotification", ticketHandler);
//   //     socket.off("userAddedNotification", assignmentHandler);
//   //   };
//   // }, [userId, isUserLoaded]);

//       // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     if (localUserType === 'manager' && !isApprovedManager) return;  

//     // join this user's room
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); } catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: new Date(data.timestamp || Date.now()),
//     });

//     // shared handler factory to prepend + sound
//     const handleIncoming = (data, allowAll = false) => {
//       const tgt = data.targetUserId?.toString();
//       if (!tgt) return;
//       if (!allowAll && tgt !== userId) return;
//       if (allowAll && tgt !== "@all" && tgt !== userId) return;

//       const n = makeNotif(data);
//       playSound();
//       setNotifications(prev => [n, ...prev]);
//       // auto-mark seen after a short delay
//       setTimeout(() => {
//         setNotifications(prev =>
//           prev.map(x => x._id === n._id ? { ...x, isSeen: true } : x)
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", data => handleIncoming(data, false));
//     socket.on("ticketNotification", data => handleIncoming(data, true));
//     socket.on("userAddedNotification", data => handleIncoming(data, true));

//     return () => {
//       socket.off("chatNotification");
//       socket.off("ticketNotification");
//      socket.off("userAddedNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // Mark all as seen
//   const handleMarkAllSeen = () => {
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
//       );
//   };

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false);
//     if (nid) await handleMarkSeen(nid);
//     fetchNotifications();       // <— refresh after closing
//     const final =
//       tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID for navigation");
//     const role = localUserType?.toLowerCase() || "client";
//     if (["manager", "general manager"].includes(role)) {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   // --- RENDER ---
//   return (
//     <>
//       {/* Draggable Notification Icon */}
//       <div
//         ref={notifRef}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//         style={{
//           position: "fixed",
//           top: position.y,
//           left: position.x,
//           cursor: "move",
//           zIndex: 10000,
//         }}
//       >
//         <button
//           id="global-notif-icon"
//           ref={iconRef}
//           style={{
//             fontSize: 20,
//             background: "none",
//             border: "none",
//             position: "relative",
//             cursor: "pointer",
//           }}
//         >
//           🔔
//           {unseenCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: -6,
//                 right: -6,
//                 background: "red",
//                 color: "#fff",
//                 width: 16,
//                 height: 16,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//               }}
//             >
//               {unseenCount}
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Notification Dropdown */}
//       {showDropdown && (
//         <div
//           style={{
//             position: "fixed",
//             top: notificationsTop,
//             left: isMobile ? 10 : iconLeft,
//             transform: isMobile ? "none" : "translateX(-100%)",
//             width: isMobile ? "calc(100vw - 20px)" : "90vw",
//             maxWidth: isMobile ? "calc(100vw - 20px)" : 400,
//             padding: 15,
//             borderRadius: 12,
//             background: "linear-gradient(135deg,#fff,#f7f7f7)",
//             zIndex: 10000,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           }}
//         >
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <strong style={{ fontSize: 16 }}>Notifications</strong>
//             <button
//               type="button"
//               onClick={handleMarkAllSeen}
//               style={{
//                 marginLeft: 10,
//                 fontSize: 12,
//                 background: "none",
//                 border: "none",
//                 color: "#007bff",
//                 cursor: "pointer",
//               }}
//             >
//               Mark all seen
//             </button>
//             <button
//               type="button"
//               onClick={() => {
//                 setShowDropdown(false);
//                 fetchNotifications();
//               }}
//               style={{
//                 position: "absolute",
//                 top: 4,
//                 right: 4,
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 color: "#888",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//           <div style={{ maxHeight: 240, overflowY: "auto" }}>
//             {Object.entries(grouped).length === 0 ? (
//               <div style={{ textAlign: "center", color: "#555" }}>
//                 No notifications
//               </div>
//             ) : (
//               Object.entries(grouped).map(([key, list]) => (
//                 <div key={key} style={{ marginBottom: 12 }}>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       fontSize: 14,
//                       marginBottom: 6,
//                       borderBottom: "1px solid #ddd",
//                       paddingBottom: 4,
//                     }}
//                   >
//                     {key !== "other" ? `Ticket: ${key}` : "General"}
//                   </div>
//                   {list.map((n) => {
//                     const tid = getTicketId(n);
//                     return (
//                       <div
//                         key={n._id}
//                         onClick={() => handleNavigateToTicket(tid, n._id)}
//                         style={{
//                           padding: 12,
//                           marginBottom: 8,
//                           borderRadius: 8,
//                           backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                           cursor: "pointer",
//                           fontSize: 15,
//                         }}
//                       >
//                         {n.message}
//                         <div
//                           style={{
//                             fontSize: 13,
//                             fontStyle: "italic",
//                             marginTop: 4,
//                             color: "#555",
//                             textDecoration: "underline",
//                           }}
//                         >
//                           Ticket: {tid || "N/A"}
//                         </div>
//                         <div
//                           style={{ fontSize: 12, color: "#555", marginTop: 4 }}
//                         >
//                           {new Date(n.timestamp).toLocaleString()}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       )}

//       {/* Small Popup Notifications */}
//       <div
//         style={{
//           position: "fixed",
//           top: notificationsTop,
//           left: isMobile ? 10 : iconLeft,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           zIndex: 9000,
//           width: isMobile ? "calc(100vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(100vw - 20px)" : 380,
//         }}
//       >
//         {notifications
//           .filter((n) => !n.isSeen)
//           .slice(-3)
//           .map((n) => (
//             <div
//               key={n._id}
//               style={{
//                 background: "#4b9ef1",
//                 color: "#fff",
//                 padding: "12px 16px",
//                 marginBottom: 10,
//                 borderRadius: 10,
//                 boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//                 fontSize: 15,
//               }}
//             >
//               {n.message}
//             </div>
//           ))}
//       </div>
//     </>
//   );
// };

// export default GlobalNotification;









// // src/components/GlobalNotification.jsx
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import socket from "./socket";
// import { UserContext } from "./userContext";
// import { backendUrl } from "./config";
// import notificationSound from "./notification-sound.mp3";

// const GlobalNotification = () => {
//   const { user, isUserLoaded } = useContext(UserContext);
//   const [localUserType, setLocalUserType] = useState(user?.usertype);
//   const isApprovedManager = localUserType === 'manager' ? user?.approved === true : true;
//   const [notifications, setNotifications] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const userId = user?._id || user?.id;
//   const navigate = useNavigate();
// //   const audioRef = useRef(new Audio("/notification-sound.mp3"));
// const audioRef = useRef(new Audio(notificationSound));

//   // Persisted position for draggable icon
//   const [position, setPosition] = useState(() => {
//     if (typeof window !== "undefined") {
//       const saved = localStorage.getItem("notifPosition");
//       if (saved) return JSON.parse(saved);
//       return { x: window.innerWidth - 50, y: 30 };
//     }
//     return { x: 300, y: 30 };
//   });

//   // Refs & state to track dropdown placement
//   const notifRef = useRef(null);
//   const iconRef = useRef(null);
//   const [notificationsTop, setNotificationsTop] = useState(0);
//   const [iconLeft, setIconLeft] = useState(0);

//   // Remove duplicate icons on mount
//   useEffect(() => {
//     const all = document.querySelectorAll("#global-notif-icon");
//     if (all.length > 1) {
//       all.forEach((el, i) => {
//         if (i < all.length - 1) el.remove();
//       });
//     }
//   }, []);

//   // Save position
//   useEffect(() => {
//     localStorage.setItem("notifPosition", JSON.stringify(position));
//   }, [position]);

//   // Update dropdown coords when icon moves
//   useEffect(() => {
//     if (iconRef.current) {
//       const rect = iconRef.current.getBoundingClientRect();
//       setNotificationsTop(rect.bottom + 8);
//       setIconLeft(rect.left);
//     }
//   }, [position]);

//   // Mobile detection & resizing
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" && window.innerWidth < 600
//   );
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 600);
//       if (iconRef.current) {
//         const rect = iconRef.current.getBoundingClientRect();
//         setNotificationsTop(rect.bottom + 8);
//         setIconLeft(rect.left);
//       }
//       // clamp within viewport
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: Math.min(Math.max(position.x, minX), maxX),
//         y: Math.min(Math.max(position.y, minY), maxY),
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [position]);

//   // Drag & drop handlers...
//   const wasDragged = useRef(false);
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragging = useRef(false);
//   const isDragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

//   const handleMouseDown = (e) => {
//     wasDragged.current = false;
//     dragStart.current = { x: e.clientX, y: e.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;
//     const dx = e.clientX - dragStart.current.x;
//     const dy = e.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 5) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleMouseUp = () => {
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };
//   const handleTouchStart = (e) => {
//     if (e.touches.length !== 1) return;
//     wasDragged.current = false;
//     const t = e.touches[0];
//     dragStart.current = { x: t.clientX, y: t.clientY };
//     dragging.current = true;
//     isDragging.current = false;
//     dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
//     document.addEventListener("touchmove", handleTouchMove);
//     document.addEventListener("touchend", handleTouchEnd);
//   };
//   const handleTouchMove = (e) => {
//     if (e.touches.length !== 1 || !dragging.current) return;
//     const t = e.touches[0];
//     const dx = t.clientX - dragStart.current.x;
//     const dy = t.clientY - dragStart.current.y;
//     if (!isDragging.current && Math.hypot(dx, dy) > 15) {
//       isDragging.current = true;
//       wasDragged.current = true;
//     }
//     if (isDragging.current) {
//       const cw = notifRef.current?.offsetWidth || 50;
//       const ch = notifRef.current?.offsetHeight || 50;
//       const minX = 10, minY = 30;
//       const maxX = window.innerWidth - cw - 10;
//       const maxY = window.innerHeight - ch - 10;
//       setPosition({
//         x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
//         y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
//       });
//     }
//   };
//   const handleTouchEnd = () => {
//     document.removeEventListener("touchmove", handleTouchMove);
//     document.removeEventListener("touchend", handleTouchEnd);
//     if (!wasDragged.current) setShowDropdown((p) => !p);
//     dragging.current = false;
//     isDragging.current = false;
//     wasDragged.current = false;
//   };

//   // Sync user type
//   useEffect(() => {
//     if (user) setLocalUserType(user.usertype || user.userType);
//   }, [user]);

//   // Helper to reload the full notifications list
//   const fetchNotifications = async () => {
//     if (!userId || !isUserLoaded) return;
//     try {
//       const res = await fetch(`${backendUrl}/notifications`, {
//         credentials: "include",
//       });
//       const data = await res.json();
//       if (res.ok && data.notifications) {
//         setNotifications(data.notifications);
//       }
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchNotifications();
//   }, [userId, isUserLoaded]);

//       // Socket listeners for real-time notifications
//   useEffect(() => {
//     if (!userId || !isUserLoaded) return;
//     if (localUserType === 'manager' && !isApprovedManager) return;  

//     // join this user's room
//     socket.emit("registerUser", userId);

//     const playSound = () => {
//       try { audioRef.current.play(); } catch {}
//     };

//     const makeNotif = (data) => ({
//       _id: Date.now().toString(),
//       message: data.message,
//       ticketId: data.ticketId || data.ticketID || data.ticketNumber,
//       from: data.from,
//       isSeen: false,
//       timestamp: new Date(data.timestamp || Date.now()),
//     });

//     // shared handler factory to prepend + sound
//     const handleIncoming = (data, allowAll = false) => {
//       const tgt = data.targetUserId?.toString();
//       if (!tgt) return;
//       if (!allowAll && tgt !== userId) return;
//       if (allowAll && tgt !== "@all" && tgt !== userId) return;

//       const n = makeNotif(data);
//       playSound();
//       setNotifications(prev => [n, ...prev]);
//       // auto-mark seen after a short delay
//       setTimeout(() => {
//         setNotifications(prev =>
//           prev.map(x => x._id === n._id ? { ...x, isSeen: true } : x)
//         );
//       }, 6000);
//     };

//     socket.on("chatNotification", data => handleIncoming(data, false));
//     socket.on("ticketNotification", data => handleIncoming(data, true));
//     socket.on("userAddedNotification", data => handleIncoming(data, true));

//     return () => {
//       socket.off("chatNotification");
//       socket.off("ticketNotification");
//      socket.off("userAddedNotification");
//     };
//   }, [userId, isUserLoaded]);

//   const unseenCount = notifications.filter((n) => !n.isSeen).length;

//   // Mark a single notification as seen
//   const handleMarkSeen = async (id) => {
//     try {
//       await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
//         method: "PATCH",
//         credentials: "include",
//       });
//       setNotifications((p) =>
//         p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
//       );
//     } catch (err) {
//       console.error("Mark seen failed:", err);
//     }
//   };

//   // Mark all as seen
//   const handleMarkAllSeen = () => {
//     setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
//     notifications
//       .filter((n) => !n.isSeen)
//       .forEach((n) =>
//         fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
//           method: "PATCH",
//           credentials: "include",
//         }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
//       );
//   };

//   const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

//   const handleNavigateToTicket = async (tid, nid) => {
//     setShowDropdown(false);
//     if (nid) await handleMarkSeen(nid);
//     fetchNotifications();       // <— refresh after closing
//     const final =
//       tid || getTicketId(notifications.find((x) => x._id === nid) || {});
//     if (!final) return console.error("No ticket ID for navigation");
//     const role = localUserType?.toLowerCase() || "client";
//     if (["manager", "general manager"].includes(role)) {
//       navigate(`/manager/${final}`);
//     } else if (role === "tasker") {
//       navigate(`/tasker/${final}`);
//     } else if (role === "implementer") {
//       navigate(`/implementer/${final}`);
//     } else {
//       navigate(`/client/${final}`);
//     }
//   };

//   const grouped = notifications.reduce((acc, n) => {
//     const key = getTicketId(n) || "other";
//     (acc[key] = acc[key] || []).push(n);
//     return acc;
//   }, {});

//   // --- RENDER ---
//   return (
//   <>
//     {/* Draggable Notification Icon */}
//     <div
//       ref={notifRef}
//       onMouseDown={handleMouseDown}
//       onTouchStart={handleTouchStart}
//       style={{
//         position: "fixed",
//         top: position.y,
//         left: position.x,
//         cursor: "move",
//         zIndex: 10000,
//       }}
//     >
//       <button
//         id="global-notif-icon"
//         ref={iconRef}
//         style={{
//           fontSize: 14,
//           background: "none",
//           border: "none",
//           position: "relative",
//           cursor: "pointer",
//         }}
//       >
//         🔔
//         {unseenCount > 0 && (
//           <span
//             style={{
//               position: "absolute",
//               top: 2,
//               right: 2,
//               background: "red",
//               color: "#fff",
//               width: 16,
//               height: 16,
//               borderRadius: "50%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 10,
//             }}
//           >
//             {unseenCount}
//           </span>
//         )}
//       </button>
//     </div>

//     {/* Notification Dropdown */}
//     {showDropdown && (
//       <div
//         style={{
//           position: "fixed",
//           // CHANGE: bring dropdown 2px closer to bell icon
//           top: notificationsTop - 20,
//           left: isMobile ? 12 : iconLeft + 16,
//           transform: isMobile ? "none" : "translateX(-100%)",
//           width: isMobile ? "calc(52vw - 20px)" : "90vw",
//           maxWidth: isMobile ? "calc(52vw - 20px)" : 400,
//           padding: 4,
//           borderRadius: 12,
//           background: "linear-gradient(135deg,#fff,#f7f7f7)",
//           zIndex: 10000,
//           boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//         }}
//       >
//         <div style={{ position: "relative", marginBottom: 2 }}>
//           <strong style={{ fontSize: 14 }}>Notifications</strong>
//           <button
//             type="button"
//             onClick={handleMarkAllSeen}
//             style={{
//               marginLeft: 10,
//               fontSize: 12,
//               background: "none",
//               border: "none",
//               color: "#007bff",
//               cursor: "pointer",
//             }}
//           >
//             Mark all seen
//           </button>
//           <button
//             type="button"
//             onClick={() => {
//               setShowDropdown(false);
//               fetchNotifications();
//             }}
//             style={{
//               position: "absolute",
//               top: 2,
//               right: 2,
//               background: "transparent",
//               border: "none",
//               cursor: "pointer",
//               color: "#888",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div style={{ maxHeight: 240, overflowY: "auto" }}>
//           {Object.entries(grouped).length === 0 ? (
//             <div style={{ textAlign: "center", color: "#555" }}>
//               No notifications
//             </div>
//           ) : (
//             Object.entries(grouped).map(([key, list]) => (
//               <div key={key} style={{ marginBottom: 10 }}>
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: 12,
//                     marginBottom: 6,
//                     borderBottom: "1px solid #ddd",
//                     paddingBottom: 4,
//                   }}
//                 >
//                   {key !== "other" ? `Ticket: ${key}` : "General"}
//                 </div>
//                 {list.map((n) => {
//                   const tid = getTicketId(n);
//                   return (
//                     <div
//                       key={n._id}
//                       onClick={() => handleNavigateToTicket(tid, n._id)}
//                       style={{
//                         padding: 12,
//                         marginBottom: 8,
//                         borderRadius: 8,
//                         backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
//                         cursor: "pointer",
//                         fontSize: 15,
//                       }}
//                     >
//                       {n.message}
//                       <div
//                         style={{
//                           fontSize: 12,
//                           fontStyle: "italic",
//                           marginTop: 4,
//                           color: "#555",
//                           textDecoration: "underline",
//                         }}
//                       >
//                         Ticket: {tid || "N/A"}
//                       </div>
//                       <div
//                         style={{ fontSize: 12, color: "#555", marginTop: 4 }}
//                       >
//                         {new Date(n.timestamp).toLocaleString()}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     )}

//     {/* Small Popup Notifications */}
//     <div
//       style={{
//         position: "fixed",
//         // already 2px closer for small popups:
//         top: notificationsTop - 20,
//         left: isMobile ? 12 : iconLeft + 16,
//         transform: isMobile ? "none" : "translateX(-100%)",
//         zIndex: 9000,
//         width: isMobile ? "calc(62vw - 20px)" : "90vw",
//         maxWidth: isMobile ? "calc(62vw - 20px)" : 380,
//       }}
//     >
//       {notifications
//         .filter((n) => !n.isSeen)
//         .slice(-3)
//         .map((n) => (
//           <div
//             key={n._id}
//             style={{
//               background: "#4b9ef1",
//               color: "#fff",
//               padding: "6px 10px",
//               marginBottom: 2,
//               borderRadius: 10,
//               boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//               fontSize: 12,
//             }}
//           >
//             {n.message}
//           </div>
//         ))}
//     </div>
//   </>
// );
// };

// export default GlobalNotification;










// src/components/GlobalNotification.jsx
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import socket from "./socket";
import { UserContext } from "./userContext";
import { backendUrl } from "./config";
import notificationSound from "./notification-sound.mp3";

const GlobalNotification = () => {
  const { user, isUserLoaded } = useContext(UserContext);
  const [localUserType, setLocalUserType] = useState(user?.usertype);
  const isApprovedManager = localUserType === 'manager' ? user?.approved === true : true;
  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const userId = user?._id || user?.id;
  const navigate = useNavigate();
//   const audioRef = useRef(new Audio("/notification-sound.mp3"));
const audioRef = useRef(new Audio(notificationSound));

  // Persisted position for draggable icon
  const [position, setPosition] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("notifPosition");
      if (saved) return JSON.parse(saved);
      return { x: window.innerWidth - 50, y: 30 };
    }
    return { x: 300, y: 30 };
  });

  // Refs & state to track dropdown placement
  const notifRef = useRef(null);
  const iconRef = useRef(null);
  const [notificationsTop, setNotificationsTop] = useState(0);
  const [iconLeft, setIconLeft] = useState(0);

  // Remove duplicate icons on mount
  useEffect(() => {
    const all = document.querySelectorAll("#global-notif-icon");
    if (all.length > 1) {
      all.forEach((el, i) => {
        if (i < all.length - 1) el.remove();
      });
    }
  }, []);

  // Save position
  useEffect(() => {
    localStorage.setItem("notifPosition", JSON.stringify(position));
  }, [position]);

  // Update dropdown coords when icon moves
  useEffect(() => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setNotificationsTop(rect.bottom + 8);
      setIconLeft(rect.left);
    }
  }, [position]);

  // Mobile detection & resizing
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 600
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
      if (iconRef.current) {
        const rect = iconRef.current.getBoundingClientRect();
        setNotificationsTop(rect.bottom + 8);
        setIconLeft(rect.left);
      }
      // clamp within viewport
      const cw = notifRef.current?.offsetWidth || 50;
      const ch = notifRef.current?.offsetHeight || 50;
      const minX = 10, minY = 30;
      const maxX = window.innerWidth - cw - 10;
      const maxY = window.innerHeight - ch - 10;
      setPosition({
        x: Math.min(Math.max(position.x, minX), maxX),
        y: Math.min(Math.max(position.y, minY), maxY),
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [position]);

  // Drag & drop handlers...
  const wasDragged = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const dragging = useRef(false);
  const isDragging = useRef(false);
  const dragOffset = useRef({ x: 0, y: 0 });

  const clamp = (v, mi, ma) => Math.min(Math.max(v, mi), ma);

  const handleMouseDown = (e) => {
    wasDragged.current = false;
    dragStart.current = { x: e.clientX, y: e.clientY };
    dragging.current = true;
    isDragging.current = false;
    dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const handleMouseMove = (e) => {
    if (!dragging.current) return;
    const dx = e.clientX - dragStart.current.x;
    const dy = e.clientY - dragStart.current.y;
    if (!isDragging.current && Math.hypot(dx, dy) > 5) {
      isDragging.current = true;
      wasDragged.current = true;
    }
    if (isDragging.current) {
      const cw = notifRef.current?.offsetWidth || 50;
      const ch = notifRef.current?.offsetHeight || 50;
      const minX = 10, minY = 30;
      const maxX = window.innerWidth - cw - 10;
      const maxY = window.innerHeight - ch - 10;
      setPosition({
        x: clamp(e.clientX - dragOffset.current.x, minX, maxX),
        y: clamp(e.clientY - dragOffset.current.y, minY, maxY),
      });
    }
  };
  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    if (!wasDragged.current) setShowDropdown((p) => !p);
    dragging.current = false;
    isDragging.current = false;
    wasDragged.current = false;
  };
  const handleTouchStart = (e) => {
    if (e.touches.length !== 1) return;
    wasDragged.current = false;
    const t = e.touches[0];
    dragStart.current = { x: t.clientX, y: t.clientY };
    dragging.current = true;
    isDragging.current = false;
    dragOffset.current = { x: t.clientX - position.x, y: t.clientY - position.y };
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);
  };
  const handleTouchMove = (e) => {
    if (e.touches.length !== 1 || !dragging.current) return;
    const t = e.touches[0];
    const dx = t.clientX - dragStart.current.x;
    const dy = t.clientY - dragStart.current.y;
    if (!isDragging.current && Math.hypot(dx, dy) > 15) {
      isDragging.current = true;
      wasDragged.current = true;
    }
    if (isDragging.current) {
      const cw = notifRef.current?.offsetWidth || 50;
      const ch = notifRef.current?.offsetHeight || 50;
      const minX = 10, minY = 30;
      const maxX = window.innerWidth - cw - 10;
      const maxY = window.innerHeight - ch - 10;
      setPosition({
        x: clamp(t.clientX - dragOffset.current.x, minX, maxX),
        y: clamp(t.clientY - dragOffset.current.y, minY, maxY),
      });
    }
  };
  const handleTouchEnd = () => {
    document.removeEventListener("touchmove", handleTouchMove);
    document.removeEventListener("touchend", handleTouchEnd);
    if (!wasDragged.current) setShowDropdown((p) => !p);
    dragging.current = false;
    isDragging.current = false;
    wasDragged.current = false;
  };

  // Sync user type
  useEffect(() => {
    if (user) setLocalUserType(user.usertype || user.userType);
  }, [user]);

  // Helper to reload the full notifications list
  const fetchNotifications = async () => {
    if (!userId || !isUserLoaded) return;
    try {
      const res = await fetch(`${backendUrl}/notifications`, {
        credentials: "include",
      });
      const data = await res.json();
      if (res.ok && data.notifications) {
        setNotifications(data.notifications);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  };

  // Initial load
  useEffect(() => {
    fetchNotifications();
  }, [userId, isUserLoaded]);

      // Socket listeners for real-time notifications
  useEffect(() => {
    if (!userId || !isUserLoaded) return;
    if (localUserType === 'manager' && !isApprovedManager) return;  

    // join this user's room
    socket.emit("registerUser", userId);

    const playSound = () => {
      try { audioRef.current.play(); } catch {}
    };

    const makeNotif = (data) => ({
      _id: Date.now().toString(),
      message: data.message,
      ticketId: data.ticketId || data.ticketID || data.ticketNumber,
      from: data.from,
      isSeen: false,
      timestamp: new Date(data.timestamp || Date.now()),
    });

    // shared handler factory to prepend + sound
    const handleIncoming = (data, allowAll = false) => {
      const tgt = data.targetUserId?.toString();
      if (!tgt) return;
      if (!allowAll && tgt !== userId) return;
      if (allowAll && tgt !== "@all" && tgt !== userId) return;

      const n = makeNotif(data);
      playSound();
      setNotifications(prev => [n, ...prev]);
      // auto-mark seen after a short delay
      setTimeout(() => {
        setNotifications(prev =>
          prev.map(x => x._id === n._id ? { ...x, isSeen: true } : x)
        );
      }, 6000);
    };

    socket.on("chatNotification", data => handleIncoming(data, false));
    socket.on("ticketNotification", data => handleIncoming(data, true));
    socket.on("userAddedNotification", data => handleIncoming(data, true));

    return () => {
      socket.off("chatNotification");
      socket.off("ticketNotification");
     socket.off("userAddedNotification");
    };
  }, [userId, isUserLoaded]);

  const unseenCount = notifications.filter((n) => !n.isSeen).length;

  // Mark a single notification as seen
  const handleMarkSeen = async (id) => {
    try {
      await fetch(`${backendUrl}/notifications/${id}/mark-seen`, {
        method: "PATCH",
        credentials: "include",
      });
      setNotifications((p) =>
        p.map((n) => (n._id === id ? { ...n, isSeen: true } : n))
      );
    } catch (err) {
      console.error("Mark seen failed:", err);
    }
  };

  // Mark all as seen
  const handleMarkAllSeen = () => {
    setNotifications((p) => p.map((n) => ({ ...n, isSeen: true })));
    notifications
      .filter((n) => !n.isSeen)
      .forEach((n) =>
        fetch(`${backendUrl}/notifications/${n._id}/mark-seen`, {
          method: "PATCH",
          credentials: "include",
        }).catch((e) => console.error(`Failed to mark ${n._id} seen:`, e))
      );
  };

  const getTicketId = (n) => n.ticketId || n.ticketID || n.ticketNumber;

  const handleNavigateToTicket = async (tid, nid) => {
    setShowDropdown(false);
    if (nid) await handleMarkSeen(nid);
    fetchNotifications();       // <— refresh after closing
    const final =
      tid || getTicketId(notifications.find((x) => x._id === nid) || {});
    if (!final) return console.error("No ticket ID for navigation");
    const role = localUserType?.toLowerCase() || "client";
    if (["manager", "general manager"].includes(role)) {
      navigate(`/manager/${final}`);
    } else if (role === "tasker") {
      navigate(`/tasker/${final}`);
    } else if (role === "implementer") {
      navigate(`/implementer/${final}`);
    } else {
      navigate(`/client/${final}`);
    }
  };

  const grouped = notifications.reduce((acc, n) => {
    const key = getTicketId(n) || "other";
    (acc[key] = acc[key] || []).push(n);
    return acc;
  }, {});

  // --- RENDER ---
  return (
  <>
    {/* Draggable Notification Icon */}
    <div
      ref={notifRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      style={{
        position: "fixed",
        top: position.y,
        left: position.x,
        cursor: "move",
        zIndex: 10000,
      }}
    >
      <button
        id="global-notif-icon"
        ref={iconRef}
        style={{
          fontSize: 14,
          background: "none",
          border: "none",
          position: "relative",
          cursor: "pointer",
        }}
      >
        🔔
        {unseenCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: 2,
              right: 2,
              background: "red",
              color: "#fff",
              width: 16,
              height: 16,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
            }}
          >
            {unseenCount}
          </span>
        )}
      </button>
    </div>

    {/* Notification Dropdown */}
    {showDropdown && (
      <div
        style={{
          position: "fixed",
          // CHANGE: bring dropdown 2px closer to bell icon
          top: notificationsTop - 20,
          left: isMobile ? 12 : iconLeft + 16,
          transform: isMobile ? "none" : "translateX(-100%)",
          width: isMobile ? "calc(52vw - 20px)" : "90vw",
          maxWidth: isMobile ? "calc(52vw - 20px)" : 400,
          padding: 4,
          borderRadius: 12,
          background: "linear-gradient(135deg,#fff,#f7f7f7)",
          zIndex: 10000,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <div style={{ position: "relative", marginBottom: 2 }}>
          <strong style={{ fontSize: 14 }}>Notifications</strong>
          <button
            type="button"
            onClick={handleMarkAllSeen}
            style={{
              marginLeft: 10,
              fontSize: 12,
              background: "none",
              border: "none",
              color: "#007bff",
              cursor: "pointer",
            }}
          >
            Mark all seen
          </button>
          <button
            type="button"
            onClick={() => {
              setShowDropdown(false);
              fetchNotifications();
            }}
            style={{
              position: "absolute",
              top: 2,
              right: 2,
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#888",
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ maxHeight: 240, overflowY: "auto" }}>
          {Object.entries(grouped).length === 0 ? (
            <div style={{ textAlign: "center", color: "#555" }}>
              No notifications
            </div>
          ) : (
            Object.entries(grouped).map(([key, list]) => (
              <div key={key} style={{ marginBottom: 10 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 12,
                    marginBottom: 6,
                    borderBottom: "1px solid #ddd",
                    paddingBottom: 4,
                  }}
                >
                  {key !== "other" ? `Ticket: ${key}` : "General"}
                </div>
                {list.map((n) => {
                  const tid = getTicketId(n);
                  return (
                    <div
                      key={n._id}
                      onClick={() => handleNavigateToTicket(tid, n._id)}
                      style={{
                        padding: 12,
                        marginBottom: 8,
                        borderRadius: 8,
                        backgroundColor: n.isSeen ? "#f2f2f2" : "#dff4ff",
                        cursor: "pointer",
                        fontSize: 15,
                      }}
                    >
                      {n.message}
                      <div
                        style={{
                          fontSize: 12,
                          fontStyle: "italic",
                          marginTop: 4,
                          color: "#555",
                          textDecoration: "underline",
                        }}
                      >
                        Ticket: {tid || "N/A"}
                      </div>
                      <div
                        style={{ fontSize: 12, color: "#555", marginTop: 4 }}
                      >
                        {new Date(n.timestamp).toLocaleString()}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
          )}
        </div>
      </div>
    )}

    {/* Small Popup Notifications */}
  </>
);
};

export default GlobalNotification;





























